/* unplugin-vue-components disabled */import __unplugin_components_1 from 'D:/workspace/space-time-web/src/components/Pagination/index.vue';
import __unplugin_components_0 from 'D:/workspace/space-time-web/src/components/SvgIcon/index.vue';
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vShow as _vShow, isRef as _isRef } from "vue";
import _imports_0 from '@/assets/images/voice.png';
import _imports_1 from '@/assets/images/historical-tasks.png';
import _imports_2 from '@/assets/images/device-information.png';
import _imports_3 from '@/assets/images/personnel-information.png';
import _imports_4 from '@/assets/images/alarm-information.png';
import _imports_5 from '@/assets/images/statistic.png';
import _imports_6 from '@/assets/images/weather.png';
const _hoisted_1 = {
  class: "page"
};
const _hoisted_2 = {
  key: 0,
  class: "one-text"
};
const _hoisted_3 = {
  class: "left_menu"
};
const _hoisted_4 = {
  key: 2,
  class: "default_view"
};
const _hoisted_5 = {
  class: "split_four"
};
const _hoisted_6 = {
  class: "play-box"
};
const _hoisted_7 = {
  class: "play-box"
};
const _hoisted_8 = {
  class: "play-box"
};
const _hoisted_9 = {
  class: "play-box"
};
const _hoisted_10 = {
  key: 3,
  class: "flight_view"
};
const _hoisted_11 = {
  class: "left_box"
};
const _hoisted_12 = {
  class: "play-box"
};
const _hoisted_13 = {
  class: "play-box"
};
const _hoisted_14 = {
  key: 0,
  class: "right_box"
};
const _hoisted_15 = {
  class: "play-box"
};
const _hoisted_16 = {
  key: 1,
  class: "right_box"
};
const _hoisted_17 = {
  class: "play-box"
};
const _hoisted_18 = {
  key: 4
};
const _hoisted_19 = {
  key: 5,
  class: "right_menu"
};
const _hoisted_20 = {
  style: {
    "height": "62rem"
  }
};
const _hoisted_21 = {
  style: {
    "height": "66rem"
  }
};
const _hoisted_22 = {
  style: {
    "height": "66rem",
    "border-right": "0.1rem solid rgba(0, 109, 184, .31373)"
  }
};
const _hoisted_23 = {
  class: "weather_box"
};
const _hoisted_24 = {
  key: 0
};
const _hoisted_25 = {
  key: 0
};
const _hoisted_26 = {
  key: 0
};
const _hoisted_27 = {
  key: 0
};
const _hoisted_28 = {
  key: 0
};
const _hoisted_29 = {
  key: 3,
  class: "no-data"
};
const _hoisted_30 = {
  style: {
    "height": "66rem"
  }
};
const _hoisted_31 = {
  style: {
    "height": "66rem",
    "border-right": "0.1rem solid #FFFFFF"
  }
};
const _hoisted_32 = {
  class: "weather_box"
};
const _hoisted_33 = {
  style: {
    "height": "1.6rem"
  }
};
const _hoisted_34 = {
  style: {
    "height": "62rem"
  }
};
const _hoisted_35 = {
  class: "weather_box"
};
const _hoisted_36 = {
  style: {
    "display": "flex",
    "justify-content": "space-between",
    "align-items": "center",
    "margin-bottom": "1.5rem",
    "padding": "1rem",
    "background": "rgba(0, 20, 40, 0.5)",
    "border-radius": "0.8rem",
    "border": "0.1rem solid rgba(0, 109, 184, .31373)"
  }
};
const _hoisted_37 = {
  class: "menu-switch"
};
const _hoisted_38 = {
  style: {
    "height": "62rem"
  }
};
const _hoisted_39 = {
  class: "ping_result_box"
};
const _hoisted_40 = {
  key: 0,
  class: "ip-cards-container"
};
const _hoisted_41 = {
  class: "card-header"
};
const _hoisted_42 = {
  class: "card-body"
};
const _hoisted_43 = {
  class: "stat-row"
};
const _hoisted_44 = {
  class: "stat-item"
};
const _hoisted_45 = {
  class: "stat-item"
};
const _hoisted_46 = {
  class: "value"
};
const _hoisted_47 = {
  class: "stat-item"
};
const _hoisted_48 = {
  class: "stat-item"
};
const _hoisted_49 = {
  key: 1,
  class: "ip-list-container"
};
const _hoisted_50 = {
  class: "query-form"
};
const _hoisted_51 = {
  class: "form-group"
};
const _hoisted_52 = {
  class: "form-group"
};
const _hoisted_53 = {
  class: "form-group"
};
const _hoisted_54 = {
  key: 0,
  class: "chart-container"
};
const _hoisted_55 = {
  key: 1,
  class: "stats"
};
const _hoisted_56 = {
  class: "stat-card"
};
const _hoisted_57 = {
  class: "value"
};
const _hoisted_58 = {
  class: "stat-card"
};
const _hoisted_59 = {
  class: "value"
};
const _hoisted_60 = {
  class: "stat-card"
};
const _hoisted_61 = {
  class: "value"
};
const _hoisted_62 = {
  class: "stat-card"
};
const _hoisted_63 = {
  class: "value"
};
const _hoisted_64 = {
  key: 2,
  class: "empty-state"
};
const _hoisted_65 = {
  key: 3,
  class: "empty-state"
};
import { getDeviceFlat, getDataTableColumn, getSdpTerminalStatus, getTaskListByDeviceId, getTaskInfo, getWeather } from "@/api/device/device";
import DatePicker from "@/components/DatePicker";
import LatencyChart from "@/components/LatencyChart";
import { useRoute } from "vue-router";
import statistic from "./statistic";
import pop from "./pop";
import control from "./control";
import car from "./car";
import tmap from "./tmap";
import onevideo from "./onevideo";
import AlarmDrtail from "@/views/base/alarm/detail.vue";
import ViewerButton from "@/views/base/task/viewerButton.vue";
import mqtt from "precompiled-mqtt";
import usePermissionStore from "@/store/modules/permission";
import { deviceVideoPlay, getInfo } from "@/api/base/device";
import axios from "axios";
import screenfull from 'screenfull';
import { downloadDat, downloadMp4Start, downloadStatusQuery, getHistoryPingResult } from "@/api/base/taskmanager";
const playBackBase = 'https://playback.satwide.com/';
export default {
  __name: 'index',
  setup(__props) {
    const permission = usePermissionStore();
    const {
      proxy
    } = getCurrentInstance();
    const router = useRoute();
    const {
      task_status
    } = proxy.useDict("task_status");
    const fullscreen = ref(false);
    const openAlarmDrtail = ref(false);
    const spilt = ref(3);
    const rightMenuIsShow = ref(false);
    const oneName = ref("");
    const openData = ref(false);
    const terminalId = ref('');
    const helicopterData = reactive({
      pathShow: false,
      pathways: []
    });
    const openTask = ref(false);
    const historyTasks = ref([]);
    const total = ref(0);
    const isShowButton = ref(true);
    const isShowButtonSwich = ref(true);
    const treeselectDevice = ref([]);
    const openDevice = ref(false);
    const formview = ref({
      fieldTemplateList: []
    });
    const formingView = ref([]);
    const airSatcomStatus = ref(false);
    const airSatcomKa = ref(false);
    const carSatcomStatus = ref(false);
    const openUser = ref(false);
    const userList = ref([]);
    const pageData = reactive({
      manMachineNumber: undefined,
      downloadMap: new Map(),
      recentlyTaskInfo: undefined,
      downloadProgressPercentage: 50,
      downloadProgress: false,
      timerpop: undefined,
      timerId: undefined,
      terminalData: {},
      topics: [],
      showMin: true,
      minIsViewer: true,
      viewerShow: true,
      playerShow: false,
      buttonShow: true,
      taskPlay: "maxTalking",
      viewerClass: "minTalking",
      maxShow: false,
      deviceInfo: {},
      carData: {},
      taskUserList: [],
      childDeviceList: [],
      taskDeviceList: [],
      icon: 'https://block-design.oss-cn-shenzhen.aliyuncs.com/project-imgs/xingzhan/index-svg/helicopter.png',
      videoSource: {},
      recordListShow: {
        one: true,
        two: true,
        three: true,
        four: true,
        five: true,
        six: true,
        seven: true
      },
      recordVideo: {
        routerList: [],
        podUrl: '',
        podList: [],
        webVtt: '',
        podPlayTime: 0,
        helicopterUrl: '',
        airUrl: '',
        UAVUrl: '',
        taskCarUrl: '',
        taskCarList: [],
        taskCarPlayTime: 0,
        ganUrl: '',
        controlUrl: '',
        controlUrlList: [],
        controPlayTime: 0,
        oneUrl: '',
        oneList: [],
        control: {
          listUrl: [],
          index: 0,
          recordList: []
        },
        car: {
          listUrl: [],
          index: 0,
          recordList: []
        },
        pod: {
          listUrl: [],
          index: 0,
          recordList: []
        }
      },
      deviceVideo: {
        podUrl: '',
        helicopterUrl: '',
        airUrl: '',
        UAVUrl: '',
        taskCarUrl: '',
        ganUrl: '',
        controlUrl: '',
        oneUrl: ''
      }
    });
    const showFourSplit = ref(false);
    const mqttPrefix = {
      flightData: 'sat_data_flight_',
      route: 'sat_data_route_',
      satcom: 'sat_data_satcom_',
      taskMsg: 'drone_task_',
      satcomNetwork: 'sat_data_ka_network_',
      satcomSignal: 'sat_data_ka_signal_',
      satcomBeam: 'sat_data_ka_beam_',
      baseStation: 'sat_data_base_station_'
    };
    const mapVideo = reactive({
      showSubtitle: true,
      controlelSize: "small"
    });
    const oneVideo = reactive({
      showSubtitle: false,
      controlelSize: "default",
      aspectRatioState: false,
      videoStartRecord: false
    });
    const switchViews = index => {
      spilt.value = index;
      pageData.viewerShow = true;
      switch (index) {
        case 0:
        case 1:
        case 2:
          pageData.showMin = true;
          pageData.minIsViewer = true;
          pageData.viewerShow = true;
          pageData.playerShow = true;
          pageData.buttonShow = true;
          pageData.taskPlay = 'maxTalking';
          pageData.viewerClass = 'minTalking';
          pageData.maxShow = false;
          break;
        case 3:
          pageData.showMin = true;
          pageData.minIsViewer = true;
          pageData.viewerShow = true;
          pageData.playerShow = true;
          pageData.buttonShow = true;
          pageData.taskPlay = 'maxTalking';
          pageData.viewerClass = 'minTalking';
          onUpdateviewerClass("showMin");
          pageData.maxShow = false;
          break;
      }
      oneVideo.controlelSize = "default";
      mapVideo.controlelSize = "small";
    };
    const token = ref("436ce7e50d27eede2f2929307e6b33c0");
    let a = Date.now();
    const client = mqtt.connect("wss://satwide.com/mqtt", {
      clientId: 'renwuyemian' + a
    });
    let lastMsg = '';
    client.on("connect", () => {
      console.log(`mqtt连接成功`);
      console.log(client);
    });
    client.on("message", (topic, message) => {
      if (topic.includes(mqttPrefix.route)) {
        if (lastMsg === message.toString()) {
          console.log("重复收到消息不处理");
          return;
        }
        lastMsg = message.toString();
        let flyRouter = JSON.parse(message.toString());
        console.log("mqtt接收到消息");
        console.log(flyRouter);
        permission.setFlyRouter(flyRouter);
        requestAnimationFrame(() => {
          sessionStorage.clear();
          proxy.$refs["taskMapRef"].drawRoute(flyRouter.waypoints);
        });
      } else if (topic.includes(mqttPrefix.satcom)) {
        let satcomData = JSON.parse(message.toString());
        console.log("mqtt接收到卫通消息");
        console.log(satcomData);
        if (satcomDataTableColumn.value.length > 0) {
          satcomDataTableColumn.value = satcomDataTableColumn.value.map(item => {
            item.value = satcomData[item.javaField];
            return item;
          });
        }
        if (pageData.deviceInfo.deviceType === "3") {
          requestAnimationFrame(() => {
            proxy.$refs["taskMapRef"].drawHelicopterFlight(satcomData);
          });
        }
      } else if (topic.includes(mqttPrefix.flightData)) {
        //TODO 飞行数据
        let flightData = JSON.parse(message.toString());
        requestAnimationFrame(() => {
          if (mapVideo.showSubtitle) {
            proxy.$refs["taskMapRef"].setFlightData(flightData);
          }
          proxy.$refs["taskMapRef"].drawFlight(flightData);
        });
      } else if (topic.includes(mqttPrefix.taskMsg)) {
        let taskData = JSON.parse(message.toString());
        if (taskData.msg === '任务已结束') {
          proxy.$modal.confirmX('此任务已经结束，点击确定返回首页', '系统提示', {
            showClose: false
          }).then(() => {
            proxy.$router.push({
              path: "/index"
            });
          });
        }
      } else if (topic.includes(mqttPrefix.satcomNetwork)) {
        let satcomData = JSON.parse(message.toString());
        //console.log("设备入网状态上报数据")
        //console.log(satcomData)
        if (networkTableColumn.value.length > 0) {
          networkTableColumn.value = networkTableColumn.value.map(item => {
            item.value = satcomData[item.javaField];
            return item;
          });
          //console.log(networkTableColumn.value)
        }
      } else if (topic.includes(mqttPrefix.satcomSignal)) {
        let satcomData = JSON.parse(message.toString());
        //console.log("信号强度上报数据")
        //console.log(satcomData)
        if (signalTableColumn.value.length > 0) {
          signalTableColumn.value = signalTableColumn.value.map(item => {
            item.value = satcomData[item.javaField];
            return item;
          });
          //console.log(signalTableColumn.value)
        }
      } else if (topic.includes(mqttPrefix.satcomBeam)) {
        let satcomData = JSON.parse(message.toString());
        //console.log("波束信息上报数据")
        //console.log(satcomData)
        if (beamTableColumn.value.length > 0) {
          beamTableColumn.value = beamTableColumn.value.map(item => {
            item.value = satcomData[item.javaField];
            return item;
          });
          //console.log(beamTableColumn.value)
        }
      } else if (topic.includes(mqttPrefix.baseStation)) {
        let baseStationData = JSON.parse(message.toString());
        //console.log("波束信息上报数据")
        //console.log(satcomData)
        if (baseStationDataColum.value.length > 0) {
          baseStationDataColum.value = baseStationDataColum.value.map(item => {
            item.value = baseStationData[item.javaField];
            return item;
          });
          //console.log(beamTableColumn.value)
        }
      }
      if (topic.includes("ping/result/")) {
        handlePingMessage(message, topic);
      }
      if (topic.includes("ping/stats/")) {
        handleStatsMessage(message, topic);
      }
    });
    client.on("error", error => {
      console.log('mqtt错误');
      conlose.log(error);
    });
    const onUpdateviewerClass = inClass => {
      if (inClass === "minTalking") {
        pageData.buttonShow = !pageData.buttonShow;
        pageData.maxShow = false;
        pageData.minIsViewer = !pageData.minIsViewer;
        pageData.taskPlay = "maxTalking";
        pageData.viewerClass = inClass;
        mapVideo.controlelSize = "small";
        oneVideo.controlelSize = "default";
      } else if (inClass === "maxTalking") {
        pageData.minIsViewer = !pageData.minIsViewer;
        pageData.buttonShow = !pageData.buttonShow;
        pageData.maxShow = true;
        pageData.taskPlay = "minTalking";
        pageData.viewerClass = inClass;
        mapVideo.controlelSize = "default";
        oneVideo.controlelSize = "samll";
      } else if (inClass === "notShowMin") {
        pageData.showMin = false;
        pageData.viewerShow = !pageData.minIsViewer;
        pageData.playerShow = pageData.minIsViewer;
        if (pageData.taskPlay === "minTalking") {
          pageData.taskPlay = "minTalkingNotShow";
        }
        if (pageData.viewerClass === "minTalking") {
          pageData.viewerClass = "minTalkingNotShow";
        }
      } else if (inClass === "showMin") {
        pageData.viewerShow = true;
        pageData.playerShow = true;
        pageData.showMin = true;
        if (pageData.taskPlay === "minTalkingNotShow") {
          pageData.taskPlay = "minTalking";
        }
        if (pageData.viewerClass === "minTalkingNotShow") {
          pageData.viewerClass = "minTalking";
        }
      }
      proxy.$refs["oneVideoRef"].updateviewer(inClass);
      proxy.$refs["taskMapRef"].updateviewer(inClass);
    };
    function initData() {
      if (history.state.type === '0') {
        pageData.topics = [];
        pageData.topics.push(mqttPrefix.taskMsg + recentlyTaskId.value);
      }
      getWeatherInfo(pageData.deviceInfo.longitude, pageData.deviceInfo.latitude);
      let label = pageData.deviceInfo.status === "1" ? "-green.svg" : "-grey.svg";
      pageData.icon = "https://block-design.oss-cn-shenzhen.aliyuncs.com/project-imgs/xingzhan/index-svg/" + proxy.getDeviceIcon(pageData.deviceInfo.deviceType) + label;
      if (['12', '13', '4', '1'].includes(pageData.deviceInfo.deviceType)) {
        //12 监控中心 13 智慧杆 4 任务车 1 多旋翼无人机
        if (pageData.deviceInfo.deviceName === undefined) {
          return;
        }
        if (pageData.deviceInfo.channelId === undefined) {
          pageData.deviceInfo.channelId = 0;
        }
        deviceVideoPlay({
          deviceName: pageData.deviceInfo.deviceName,
          channelId: pageData.deviceInfo.channelId,
          deviceType: pageData.deviceInfo.deviceType
        }).then(res => {
          if (res.code === 200) {
            if (res.msg === '暂无推流信息') {
              return;
            } else if (res.msg === '操作成功') {
              pageData.deviceVideo.controlUrl = res.data.wss_flv;
              pageData.deviceVideo.oneUrl = res.data.wss_flv;
              pageData.playerShow = true;
            }
          }
        });
      } else if (pageData.deviceInfo.deviceType === '3') {
        // 3为 直升机
        //在线任务执行：播放吊舱画面 订阅天线信息
        if (history.state.isTasking) {
          for (let dev of pageData.childDeviceList) {
            if (dev.deviceType === '5') {
              if (dev.deviceName) {
                if (dev.channelId === undefined) {
                  dev.channelId = 0;
                }
                deviceVideoPlay({
                  deviceName: dev.deviceName,
                  channelId: dev.channelId,
                  deviceType: dev.deviceType
                }).then(res => {
                  if (res.code === 200) {
                    if (res.msg === '暂无推流信息') {
                      return;
                    } else if (res.msg === '操作成功') {
                      pageData.deviceVideo.helicopterUrl = res.data.wss_flv;
                      pageData.deviceVideo.oneUrl = res.data.wss_flv;
                      pageData.playerShow = true;
                    }
                  }
                });
              }
            } else if (dev.deviceType === '6') {
              client.unsubscribe(pageData.topics);
              pageData.topics.push(mqttPrefix.satcom + dev.uid);
              client.subscribe(pageData.topics, {
                qos: 2
              }, () => {
                console.log(`订阅了卫通消息主题 ${pageData.topics.join('和')}`);
                console.log(client);
                helicopterData.pathShow = true;
              });
              getInfo(dev.id).then(res => {
                for (let temp of res.data.fieldTemplateList) {
                  if (temp.field === 'terminalId') {
                    terminalId.value = temp.value;
                  }
                }
              });
            }
          }
        }
      } else if (pageData.deviceInfo.deviceType === '0') {
        spilt.value = 0;
        console.log("无人机跳转进入");
        //调整地图位置
        //在线任务： 播放吊舱，任务车，监控中心 订阅无人机飞行信息 订阅无人机航线信息
        //
        if (history.state.isTasking) {
          pageData.topics.push(mqttPrefix.flightData + pageData.deviceInfo.uid);
          pageData.topics.push(mqttPrefix.route + pageData.deviceInfo.uid);
          client.subscribe(pageData.topics, {
            qos: 2
          }, () => {
            console.log(`订阅了无人机2主题 ${pageData.topics.join('和')}`);
            console.log(client);
          });
          for (let dev of pageData.childDeviceList) {
            if (dev.deviceType === '6') {
              client.unsubscribe(pageData.topics);
              pageData.topics.push(mqttPrefix.satcom + dev.uid);
              pageData.topics.push(mqttPrefix.satcomNetwork + dev.uid);
              pageData.topics.push(mqttPrefix.satcomSignal + dev.uid);
              pageData.topics.push(mqttPrefix.satcomBeam + dev.uid);
              client.subscribe(pageData.topics, {
                qos: 2
              }, () => {
                console.log(`订阅了无人机卫通消息主题 ${pageData.topics.join('和')}`);
              });
              getInfo(dev.id).then(res => {
                for (let temp of res.data.fieldTemplateList) {
                  if (temp.field === 'terminalId') {
                    terminalId.value = temp.value;
                  }
                }
              });
            }
            if (dev.deviceType === '7') {
              client.unsubscribe(pageData.topics);
              pageData.topics.push(mqttPrefix.baseStation + dev.uid);
              client.subscribe(pageData.topics, {
                qos: 2
              }, () => {
                console.log(`订阅了无人机基站消息主题 ${pageData.topics.join('和')}`);
              });
            }
          }
        }
      } else if (pageData.deviceInfo.deviceType === '2') {
        //固定有人机进入飞行视图
        spilt.value = 2;
      }
      switchViews(spilt.value);
      //实时任务采用此方法进行播放请求
      if (history.state.isTasking) {
        for (let dev of pageData.childDeviceList) {
          if (dev.deviceName === undefined) {
            continue;
          }
          if (dev.channelId === undefined) {
            pageData.deviceInfo.channelId = 0;
          }
          if (dev.deviceName) {
            deviceVideoPlay({
              deviceName: dev.deviceName,
              channelId: dev.channelId,
              deviceType: dev.deviceType
            }).then(resa => {
              if (resa.code === 200 && resa.msg === '操作成功') {
                if (dev.deviceType === "4") {
                  pageData.deviceVideo.taskCarUrl = resa.data.artc;
                  pageData.deviceVideo.taskCarFlvUrl = resa.data.wss_flv;
                } else if (dev.deviceType === "5") {
                  pageData.deviceVideo.podUrl = resa.data.artc;
                  pageData.deviceVideo.podFlvUrl = resa.data.wss_flv;
                  pageData.deviceVideo.oneUrl = resa.data.artc;
                  pageData.playerShow = true;
                } else if (dev.deviceType === "12") {
                  pageData.deviceVideo.controlUrl = resa.data.wss_flv;
                }
              }
            });
          }
        }
      } else {
        //历史任务 ： 播放吊舱录像，加载hud历史文件
        if (pageData.videoSource) {
          if (pageData.videoSource.podUrl) {
            pageData.recordVideo.podUrl = playBackBase + pageData.videoSource.podUrl[0].uri;
            pageData.deviceVideo.oneUrl = playBackBase + pageData.videoSource.podUrl[0].uri;
            pageData.recordVideo.webVtt = pageData.videoSource.podUrl[0].hudFileName;
            pageData.recordVideo.podIndex = pageData.videoSource.podUrl[0].liveRecordStartTime;
            pageData.recordVideo.podList = pageData.videoSource.podUrl;
            pageData.recordVideo.podPlayTime = pageData.videoSource.podUrl[0].lastPlayTime;
            console.log("吊舱播放时间");
            console.log(pageData.recordVideo.podPlayTime);
            pageData.playerShow = true;
          }
          if (pageData.videoSource.control) {
            pageData.recordVideo.controlUrl = playBackBase + pageData.videoSource.control[0].uri;
            pageData.recordVideo.controlUrlList = pageData.videoSource.control;
            pageData.recordVideo.controlIndex = pageData.videoSource.control[0].liveRecordStartTime;
            pageData.recordVideo.controlPlayTime = pageData.videoSource.control[0].lastPlayTime;
          }
          if (pageData.videoSource.carUrl) {
            pageData.recordVideo.taskCarUrl = playBackBase + pageData.videoSource.carUrl[0].uri;
            pageData.recordVideo.taskCarList = pageData.videoSource.carUrl;
            pageData.recordVideo.taskCarIndex = pageData.videoSource.carUrl[0].liveRecordStartTime;
            pageData.recordVideo.taskCarPlayTime = pageData.videoSource.carUrl[0].lastPlayTime;
          }
        }
      }
    }
    //录像下载
    function downloadFile(url) {
      return new Promise((resolve, reject) => {
        const a = document.createElement('a');
        a.href = url;
        a.download = url.split('/').pop(); // 提取文件名作为下载的文件名
        a.style.display = 'none'; // 隐藏元素
        document.body.appendChild(a); // 将元素添加到body中

        // 模拟点击后移除元素，并使用setTimeout确保点击事件被处理
        a.onclick = function () {
          document.body.removeChild(a); // 下载开始后从body中移除元素
          resolve(); // 下载开始，解决Promise
        };
        a.click(); // 模拟点击
      });
    }
    const downloadMp4ByTask = row => {
      let a = {
        "taskID": row.taskId,
        "downloadLabel": "pod"
      };
      downloadMp4Start(a).then(res => {
        console.log(res);
        if (res.code === 200) {
          if (res.msg === '已完成') {
            let downloadMp4Readies = permission.downloadMp4Ready;
            if (downloadMp4Readies.indexOf(row.taskName + 'pod') === -1) {
              downloadMp4Readies.push(row.taskName + 'pod');
              permission.setDownloadMp4Ready(downloadMp4Readies);
            }
            const baseUrl = 'https://satwide.com/mp4download/' + row.taskName + 'pod.mp4';
            downloadFile(baseUrl);
          } else if (res.msg === '正在下载') {
            proxy.$modal.msgSuccess("后台正在准备视频，请您稍等");
            let downloads = permission.downloadMp4;
            if (downloads.indexOf(row.taskName + 'pod') === -1) {
              downloads.push(row.taskName + 'pod');
              permission.setDownloadMp4(downloads);
            }
            /* //启动一个定时器
             pageData.timerpop  =  setInterval(()=>{
               downloadMp4StatusQuery(taskID,label)
             },5000)*/
          }
        }
      });
      console.log("点击了下载视频");
    };
    const downloadTxtByTask = row => {
      let a = {
        "taskID": row.taskId,
        "downloadLabel": row.taskName
      };
      let downloadDatNons = permission.downloadDatNon;
      let downloadDatReadies = permission.downloadDatReady;
      downloadDat(a).then(res => {
        console.log(res);
        if (res.code === 200) {
          if (res.msg === '有文件') {
            if (downloadDatReadies.indexOf(row.taskId) === -1) {
              downloadDatReadies.push(row.taskId);
              permission.setDownloadDatReady(downloadDatReadies);
            }
            const baseUrl = 'https://satwide.com/datdownload/' + row.taskName + '.dat';
            downloadFile(baseUrl);
          } else if (res.msg === '无文件') {
            if (downloadDatNons.indexOf(row.taskId) === -1) {
              downloadDatNons.push(row.taskId);
              permission.setDownloadDatNon(downloadDatNons);
              console.log(permission.downloadDatNon);
            }
            proxy.$modal.msgWarning("此架次飞行时航线数据未上报至平台");
          }
        }
      });
    };
    const downloadProgressFormat = percentage => {
      return percentage === 100 ? '已完成' : `下载中`;
    };
    const downloadMp4 = (taskID, label) => {
      console.log("下载视频");
      console.log(taskID);
      console.log(label);
      let a = {
        "taskID": taskID,
        "downloadLabel": label
      };
      downloadMp4Start(a).then(res => {
        console.log(res);
        if (res.code === 200) {
          if (res.msg === '已完成') {
            const baseUrl = 'https://satwide.com/mp4download/' + pageData.recentlyTaskInfo.taskName + label + '.mp4';
            downloadFile(baseUrl);
          } else if (res.msg === '正在下载') {
            proxy.$modal.msgSuccess("后台正在准备视频，请您稍等");
            pageData.downloadProgress = true;
            pageData.downloadProgressPercentage = 50;
            let downloads = permission.downloadMp4;
            if (downloads.indexOf(pageData.recentlyTaskInfo.taskName + label) === -1) {
              downloads.push(pageData.recentlyTaskInfo.taskName + label);
              permission.setDownloadMp4(downloads);
            }
            /* //启动一个定时器
             pageData.timerpop  =  setInterval(()=>{
               downloadMp4StatusQuery(taskID,label)
             },5000)*/
          }
        }
      });
    };
    const downloadMp4StatusQuery = (taskID, label) => {
      console.log("正在查询");
      let a = {
        "taskID": taskID,
        "downloadLabel": label
      };
      downloadStatusQuery(a).then(res => {
        if (res.code === 200) {
          if (res.msg === '已完成') {
            console.log("正在查询查询到已完成");
            clearTimeout(pageData.timerpop);
            pageData.downloadProgressPercentage = 100;
            downloadFile('https://satwide.com/mp4download/' + pageData.recentlyTaskInfo.taskName + label + '.mp4');
            pageData.downloadProgress = false;
          } else {
            if (pageData.downloadProgressPercentage < 95) {
              pageData.downloadProgressPercentage++;
            }
          }
        }
      });
    };
    const switchVideo = (index, i) => {
      if (i === 1) {
        if (index > pageData.recordVideo.podList.length) return;
        let info = pageData.recordVideo.podList[index];
        pageData.recordVideo.podUrl = playBackBase + info.uri;
        pageData.deviceVideo.oneUrl = playBackBase + info.uri;
        pageData.recordVideo.webVtt = info.hudFileName;
        pageData.recordVideo.podIndex = info.liveRecordStartTime;
        pageData.recordVideo.podPlayTime = info.lastPlayTime;
        pageData.recordVideo.podId = 'pod' + index;
      } else if (i === 2) {
        if (index > pageData.recordVideo.controlUrlList.length) return;
        let info = pageData.recordVideo.controlUrlList[index];
        pageData.recordVideo.controlUrl = playBackBase + info.uri;
        pageData.recordVideo.controlIndex = info.liveRecordStartTime;
        pageData.recordVideo.controlPlayTime = info.lastPlayTime;
        pageData.recordVideo.controlId = 'control' + index;
      } else if (i === 3) {
        if (index > pageData.recordVideo.taskCarList.length) return;
        let info = pageData.recordVideo.taskCarList[index];
        pageData.recordVideo.taskCarUrl = playBackBase + info.uri;
        pageData.recordVideo.taskCarIndex = info.liveRecordStartTime;
        pageData.recordVideo.taskCarPlayTime = info.lastPlayTime;
        pageData.recordVideo.taskCarId = "taskCar" + index;
      }
    };
    function setyataiValue(terminalId) {
      if (terminalId === null) {
        return;
      }
      getSdpTerminalStatus(terminalId).then(res => {
        if (res.code === 200) {
          pageData.terminalData = res.data;
          console.log(res);
          console.log(pageData.terminalData);
          if (yataiTableColumn.value.length > 0) {
            yataiTableColumn.value = yataiTableColumn.value.map(item => {
              if (pageData.terminalData[item.javaField] !== null) {
                item.value = pageData.terminalData[item.javaField];
                return item;
              }
            });
          }
          //防止http请求过慢，实时信息保存在一个变量中，会发生脏数据
          // 过滤请求到的数据为空的数据
          if (airSatcomStatus.value || carSatcomStatus.value) {
            formingView.value = yataiTableColumn.value.filter(item => {
              return item.value;
            });
          }
        }
      });
    }
    const recentlyTaskId = ref(undefined);
    const dateRange = ref([]); // 日期范围
    const queryParams = reactive({
      pageNum: 1,
      pageSize: 10,
      deviceId: undefined,
      taskName: undefined,
      taskStatus: undefined
    });
    const showTasks = () => {
      openTask.value = true;
    };
    function setDateRange(val) {
      dateRange.value = val;
      console.log(dateRange.value);
    }
    function getHistoryTaskList() {
      queryParams.deviceId = history.state.id;
      getTaskListByDeviceId(proxy.addDateRange(queryParams, dateRange.value, "task")).then(res => {
        historyTasks.value = res.rows;
        total.value = res.total;
      });
    }
    function handleQuery() {
      queryParams.pageNum = 1;
      getHistoryTaskList();
    }
    function clickRow(row) {
      //清除地图上所有覆盖物
      proxy.$refs["taskMapRef"].clearOverLays();
      client.unsubscribe(pageData.topics);
      recentlyTaskId.value = row.taskId;
      history.state.taskId = row.taskId;
      openTask.value = false;
      console.log("点击历史任务：", row.taskName);
      console.log("点击历史任务：", row);
      pageData.recentlyTaskInfo = row;
      if (row.taskStatus === 1) {
        history.state.isTasking = true;
        initPage(null);
      } else if (row.taskStatus === 2) {
        history.state.isTasking = false;
        initPage(row.taskId);
      }
    }
    function resetQuery() {
      dateRange.value = [];
      proxy.$refs["datePickerRef"].reset();
      proxy.resetForm("queryRef");
      handleQuery();
    }
    function taskTimesFormat(row) {
      var taskMonth = row.taskMonth < 10 ? "0" + row.taskMonth : row.taskMonth;
      var taskDay = row.taskDay < 10 ? "0" + row.taskDay : row.taskDay;
      return "" + row.taskYear + taskMonth + taskDay + '-' + row.taskTimes;
    }
    const showDevices = () => {
      treeselectDevice.value = treeselectDevice.value.filter(item => {
        return item.id !== 0;
      });
      if (['0', '1'].includes(pageData.deviceInfo.deviceType)) {
        formingView.value = flightDataTableColumn.value;
      } else {
        formingView.value = [];
      }
      openDevice.value = true;
    };
    function showItemLabel(type, map, value) {
      var label = "";
      if (type === 5 && map !== undefined && value !== undefined) {
        map.map(item => {
          if (value === item.value) {
            label = item.label;
          }
        });
      } else if (type === 6 && map !== undefined && value !== undefined) {
        value.map(item1 => {
          map.map(item => {
            if (item1 === item.value) {
              label += item.label + " ";
            }
          });
        });
      }
      return label;
    }
    function handleNodeClickInvariant(data) {
      if (data.type === 'personnel') {
        formview.value = undefined;
        return;
      }
      formview.value = {};
      if (data.type) {
        if ("air" === data.type) {
          formview.value = pageData.deviceInfo;
        } else {
          formview.value = pageData.carData;
        }
      } else {
        pageData.childDeviceList.map(item => {
          if (item.id === data.id) {
            formview.value = item;
          }
        });
      }
    }
    function handleNodeClickRealTime(data) {
      airSatcomStatus.value = false;
      carSatcomStatus.value = false;
      formingView.value = [];
      clearTimeout(pageData.timerId);
      if (['0', '1'].includes(data.deviceType)) {
        //无人机的飞控数据、
        formingView.value = flightDataTableColumn.value;
      } else if (['2', '3'].includes(data.deviceType)) {
        formingView.value = [];
      } else if (data.deviceType === "6") {
        if (data.parentClass === 'car') {
          carSatcomStatus.value = true;
          if (data.terminalId) {
            setyataiValue(data.terminalId);
            pageData.timerId = setInterval(() => {
              setyataiValue(data.terminalId);
            }, 5000);
          }
        } else {
          airSatcomStatus.value = true;
          if (data.terminalId) {
            setyataiValue(data.terminalId);
            pageData.timerId = setInterval(() => {
              setyataiValue(data.terminalId);
            }, 5000);
          } else {
            if (data.isair) {
              airSatcomKa.value = true;
            }
          }
        }
      } else if (data.deviceType === "7") {
        formingView.value = baseStationDataColum.value;
      } else {
        formingView.value = [];
      }
    }
    function getDeviceInfo(id) {
      getInfo(id).then(res => {
        pageData.deviceInfo = res.data;
        setTargets(res.data);
        console.log("直升机设备信息" + pageData.deviceInfo);
        for (let temp of res.data.fieldTemplateList) {
          if (temp.field === 'man_machine_number') {
            pageData.manMachineNumber = temp.value;
          }
        }
      });
    }
    function closeDialog() {
      formview.value = {};
      formingView.value = [];
      openDevice.value = false;
      airSatcomStatus.value = false;
      openUser.value = false;
      clearTimeout(pageData.timerId);
    }
    const showStatistic = () => {
      proxy.$refs["taskStatisticRef"].show(recentlyTaskId.value);
    };
    const showALarmDetail = () => {
      openAlarmDrtail.value = true;
    };
    const showUsers = () => {
      let users = {
        id: 0,
        label: '人员信息',
        type: "personnel",
        children: []
      };
      if (!treeselectDevice.value.some(item => JSON.stringify(item) === JSON.stringify(users))) {
        treeselectDevice.value.push(users);
      }
      formview.value = pageData.deviceInfo;
      openUser.value = true;
    };
    const closeAlarmDrtailDialog = () => {
      openAlarmDrtail.value = false;
    };
    const getRecentlyTaskInfo = deviceData => {
      getTaskInfo(deviceData).then(res => {
        if ("该设备未关联任务信息" === res.msg) {
          return;
        }
        pageData.recentlyTaskInfo = res.data;
        treeselectDevice.value = [];
        recentlyTaskId.value = res.data.taskId;
        let airData;
        let podData;
        let satData;
        let otherDeviceData;
        let controlData;
        let taskUsers;
        let carData;
        let carChildData;
        try {
          airData = JSON.parse(res.data.airData);
        } catch (e) {
          airData = null;
        }
        try {
          podData = JSON.parse(res.data.podData);
        } catch (e) {
          podData = null;
        }
        try {
          satData = JSON.parse(res.data.satData);
        } catch (e) {
          satData = null;
        }
        try {
          otherDeviceData = JSON.parse(res.data.otherDeviceData);
        } catch (e) {
          otherDeviceData = null;
        }
        try {
          controlData = JSON.parse(res.data.controlData);
        } catch (e) {
          controlData = null;
        }
        try {
          carData = JSON.parse(res.data.carData);
        } catch (e) {
          carData = null;
        }
        try {
          carChildData = JSON.parse(res.data.carChildData);
        } catch (e) {
          carChildData = null;
        }
        try {
          taskUsers = JSON.parse(res.data.taskUsers);
        } catch (e) {
          taskUsers = null;
        }
        oneName.value = res.data.taskInfo.taskName + "(" + proxy.parseTime(res.data.taskInfo.taskStarttime, '{y}/{m}/{d}') + ")";
        if (taskUsers) {
          userList.value = taskUsers;
        }
        pageData.deviceInfo = airData;
        console.log("设备信息");
        console.log(airData);
        getDeviceInfo(airData.id);
        let childs = [];
        if (podData) {
          pageData.childDeviceList.push(podData);
          childs.push({
            parentClass: 'air',
            id: podData.id,
            label: podData.name,
            deviceType: podData.deviceType
          });
        }
        if (satData) {
          pageData.childDeviceList.push(satData);
          childs.push({
            parentClass: 'air',
            id: satData.id,
            uid: satData.uid,
            isair: pageData.deviceInfo.deviceType === "3" ? false : true,
            label: satData.name,
            deviceType: satData.deviceType,
            terminalId: satData.fieldTemplateList.find(temp => {
              return temp.field === 'terminalId';
            })?.value
          });
        }
        if (otherDeviceData) {
          otherDeviceData.map(item => {
            pageData.childDeviceList.push(item);
            childs.push({
              parentClass: 'air',
              id: item.id,
              label: item.name,
              deviceType: item.deviceType
            });
          });
        }
        treeselectDevice.value.push({
          id: pageData.deviceInfo.id,
          label: pageData.deviceInfo.name,
          type: "air",
          children: childs,
          deviceType: pageData.deviceInfo.deviceType
        });
        if (carData) {
          pageData.carData = carData;
          pageData.childDeviceList.push(carData);
          let carchilds = [];
          if (carChildData) {
            carChildData.map(item => {
              // TODO 任务车天线
              pageData.childDeviceList.push(item);
              carchilds.push({
                parentClass: 'car',
                id: item.id,
                label: item.name,
                deviceType: item.deviceType,
                terminalId: item.fieldTemplateList.find(temp => {
                  return temp.field === 'terminalId';
                })?.value
              });
            });
          }
          treeselectDevice.value.push({
            id: carData.id,
            label: carData.name,
            type: "car",
            children: carchilds,
            deviceType: carData.deviceType
          });
        }
        if (controlData) {
          pageData.childDeviceList.push(controlData);
        }
        if (!history.state.isTasking) {
          isTasking.value = false;
          console.log("跳转进入历史任务");
          let videoSource = '';
          if (res.data.videoSource) {
            videoSource = JSON.parse(res.data.videoSource);
          }
          if (res.data.routeWaypoints) {
            console.log(res.data.routeWaypoints);
            if (res.data.routeWaypoints.length > 0) {
              pageData.recordVideo.routerList = res.data.routeWaypoints;
              let flyRouter = JSON.parse(pageData.recordVideo.routerList[0].waypoints);
              permission.setFlyRouter(flyRouter);
              proxy.$refs["taskMapRef"].drawRoute(flyRouter.waypoints);
            }
          }
          if (videoSource !== '') {
            pageData.videoSource = videoSource;
          }
        } else {
          console.log("跳转进入实时任务");
          isTasking.value = true;
        }
        initData();
      });
    };
    const handleChildEvent = data => {
      let flightData = JSON.parse(data);
      requestAnimationFrame(() => {
        if (pageData.deviceInfo.deviceType === '3') {
          proxy.$refs["taskMapRef"].drawHelicopterFlight(flightData);
          if (satcomDataTableColumn.value.length > 0) {
            satcomDataTableColumn.value = satcomDataTableColumn.value.map(item => {
              item.value = flightData[item.javaField];
              return item;
            });
          }
        } else {
          if (mapVideo.showSubtitle) {
            proxy.$refs["taskMapRef"].setFlightData(flightData);
          }
          proxy.$refs["taskMapRef"].drawFlight(flightData);
        }
      });
    };
    const handleChildEventTimeBack = data => {
      console.log("子组件数据来了");
      console.log(data);
      if (data.indexOf('moveTime_pod') > -1) {
        proxy.$refs["taskMapRef"].clearFlightLines();
        proxy.$refs["taskMapRef"].initECharts();
      } else if (data.indexOf('endTime') > -1) {
        let arrString = data.split('_');
        console.log(arrString);
        let aa = arrString[2];
        console.log(aa);
        let typeDev = aa.substring(0, aa.length - 1) === 'pod' ? 1 : aa.substring(0, aa.length - 1) === 'control' ? 2 : 3;
        let index = parseInt(data.substring(data.length - 1, data.length));
        console.log(typeDev);
        console.log(index);
        switchVideo(index + 1, typeDev);
      }
    };
    const initPage = taskId => {
      //置空第一次页面显示的数据
      //1.3个视频画面
      pageData.recordVideo = {
        podId: 'pod0',
        controlId: 'control0',
        taskCarId: 'taskCar0',
        routerList: [],
        podUrl: '',
        podList: [],
        podIndex: 0,
        taskCarIndex: 0,
        controlIndex: 0,
        webVtt: '',
        podPlayTime: 0,
        helicopterUrl: '',
        airUrl: '',
        UAVUrl: '',
        taskCarUrl: '',
        taskCarList: [],
        taskCarPlayTime: 0,
        ganUrl: '',
        controlUrl: '',
        controlUrlList: [],
        controlPlayTime: 0,
        oneUrl: '',
        oneList: [],
        control: {
          listUrl: [],
          index: 0,
          recordList: []
        },
        car: {
          listUrl: [],
          index: 0,
          recordList: []
        },
        pod: {
          listUrl: [],
          index: 0,
          recordList: []
        }
      };
      pageData.deviceVideo = {
        podUrl: '',
        podFlvUrl: '',
        helicopterUrl: '',
        airUrl: '',
        UAVUrl: '',
        taskCarUrl: '',
        taskCarFlvUrl: '',
        ganUrl: '',
        controlUrl: '',
        oneUrl: ''
      };
      console.log("路由数据");
      console.log(history.state);
      sessionStorage.clear();
      rightMenuIsShow.value = history.state.type === '0';
      if (['12', '13', '4', '1', '2', '3'].includes(history.state.type)) {
        spilt.value = 3;
        //12 监控中心 13 智慧杆 4 任务车 1 多旋翼无人机 2 固定翼有人机 3 直升机
        switchViews(3);
        if (history.state.type === '3') {
          isShowButton.value = false;
          isShowButtonSwich.value = true;
          if (taskId) {
            recentlyTaskId.value = taskId;
            history.state.taskId = taskId;
            getRecentlyTaskInfo({
              "deviceId": history.state.id,
              "taskId": recentlyTaskId.value
            });
          } else {
            recentlyTaskId.value = history.state.taskId;
            if (history.state.taskId) {
              getRecentlyTaskInfo({
                "deviceId": history.state.id,
                "taskId": recentlyTaskId.value
              });
            } else {
              getDeviceAndFlat(history.state.id);
            }
          }
          getHistoryTaskList();
        }
      } else if (history.state.type === '0') {
        spilt.value = 0;
        switchViews(0);
        if (taskId) {
          recentlyTaskId.value = taskId;
          history.state.taskId = taskId;
        } else {
          if (history.state.taskId) {
            recentlyTaskId.value = history.state.taskId;
          }
        }
        //根据设备Id获取设备相关的所有任务信息
        getHistoryTaskList();
        //根据设备Id获取最近的一次任务相关信息
        getRecentlyTaskInfo({
          "deviceId": history.state.id,
          "taskId": recentlyTaskId.value
        });
        console.log("默认视图加载成功");
      }
      getDataTableColumnDetile("yatai");
      getDataTableColumnDetile("flightdata");
      getDataTableColumnDetile("satcomdata");
      getDataTableColumnDetile("network");
      getDataTableColumnDetile("signal");
      getDataTableColumnDetile("beam");
      getDataTableColumnDetile("4gbasestation");
    };
    const getDeviceAndFlat = deviceId => {
      getDeviceFlat(deviceId).then(res => {
        if (res.code !== 200) return;
        pageData.deviceInfo = res.parent;
        pageData.childDeviceList = res.devices;
        for (let temp of res.parent.fieldTemplateList) {
          if (temp.field === 'man_machine_number') {
            pageData.manMachineNumber = temp.value;
          }
        }
        console.log("任务视图加载成功");
        console.log("deviceType" + pageData.deviceInfo.deviceType);
        oneName.value = pageData.deviceInfo.name + "(" + proxy.parseTime(new Date(), '{y}/{m}/{d}') + ")";
        isTasking.value = true;
        treeselectDevice.value = [];
        let childs = [];
        for (let dev of pageData.childDeviceList) {
          if (dev.deviceType !== "12") {
            childs.push({
              parentClass: 'air',
              id: dev.id,
              label: dev.name,
              deviceType: dev.deviceType,
              terminalId: dev.fieldTemplateList.find(temp => {
                return temp.field === 'terminalId';
              })?.value
            });
          }
        }
        treeselectDevice.value.push({
          id: pageData.deviceInfo.id,
          label: pageData.deviceInfo.name,
          type: "air",
          children: childs,
          deviceType: pageData.deviceInfo.deviceType
        });
        initData();
      });
    };
    const isTasking = ref(false);
    watch(() => history.state.isTasking, newVal => {
      if (newVal) {
        isTasking.value = true;
      } else {
        isTasking.value = false;
      }
    });
    function KeyDown(event) {
      if (event.keyCode === 122) {
        event.returnValue = false;
        //不支持screenfull全屏，则打印错误
        if (!screenfull.isEnabled) {
          console.error("unEnabled screenfull");
          return;
        }
        screenfull.toggle();
      }
    }
    onMounted(() => {
      handleFullScreen();
      window.addEventListener("keydown", KeyDown, true);
      document.addEventListener("fullscreenchange", changeFullscreen);
      nextTick(() => {
        initPage(null);
      });
      /*document.addEventListener("visibilitychange", function() {
        let string = document.visibilityState
        console.log(string)
        if (string === 'hidden') {  // 当页面由前端运行在后端时，出发此代码
          console.log('我被隐藏了')
          proxy.$refs["podVideoRef"].pause()
          proxy.$refs["carVideoRef"].pause()
          proxy.$refs["controlVideoRef"].pause()
        }
        if (string === 'visible') {   // 当页面由隐藏至显示时
          console.log('欢迎回来')
          proxy.$refs["podVideoRef"].play()
          proxy.$refs["carVideoRef"].play()
          proxy.$refs["controlVideoRef"].play()
        }
      });*/
    });
    const yataiTableColumn = ref([]);
    const flightDataTableColumn = ref([]);
    const satcomDataTableColumn = ref([]);
    const baseStationDataColum = ref([]);
    const networkTableColumn = ref([]);
    const signalTableColumn = ref([]);
    const beamTableColumn = ref([]);
    const getDataTableColumnDetile = key => {
      getDataTableColumn(key).then(res => {
        if ("yatai" === key) {
          yataiTableColumn.value = res.data;
        } else if ("flightdata" === key) {
          flightDataTableColumn.value = res.data;
        } else if ("satcomdata" === key) {
          satcomDataTableColumn.value = res.data;
        } else if ("network" === key) {
          networkTableColumn.value = res.data;
        } else if ("signal" === key) {
          signalTableColumn.value = res.data;
        } else if ("4gbasestation" === key) {
          baseStationDataColum.value = res.data;
        } else if ("beam" === key) {
          beamTableColumn.value = res.data;
        }
      });
    };
    let num = 0;
    function setRealMessage(flightData) {
      if (num === 0 || num % 100 === 0) {
        //天气信息页面实时数据
        getWeatherInfo(flightData.longitude, flightData.latitude);
      }
      if (num === 0 || num % 5 === 0) {
        //设备信息页面实时数据
        if (flightDataTableColumn.value.length > 0) {
          flightDataTableColumn.value = flightDataTableColumn.value.map(item => {
            item.value = flightData[item.javaField];
            return item;
          });
        }
      }
      num++;
    }
    function changeFullscreen() {
      if (screenfull.isFullscreen) {
        fullscreen.value = true;
      } else {
        fullscreen.value = false;
      }
    }
    onUnmounted(() => {
      console.log("页面关闭");
      client.end(true, {}, () => {
        console.log("关闭mqttclient");
      });
      sessionStorage.clear();
      permission.setFlyRouter(undefined);
      if (screenfull.isEnabled) {
        if (screenfull.isFullscreen) {
          screenfull.toggle();
          fullscreen.value = false;
          // screenfull.exit()
        }
      }
      window.removeEventListener("keydown", KeyDown, false);
      document.removeEventListener("fullscreenchange", changeFullscreen);
    });
    //发送数据到子页面
    provide("recentlyTaskId", recentlyTaskId);
    provide("pageData", pageData);
    provide("onUpdateviewerClass", onUpdateviewerClass);
    provide("handleChildEvent", handleChildEvent);
    provide("handleChildEventTimeBack", handleChildEventTimeBack);
    provide("switchVideo", switchVideo);
    provide("setRealMessage", setRealMessage);
    function goBack() {
      client.unsubscribe(pageData.topics, {}, () => {
        console.log(`页面返回取消订阅 ${pageData.topics.join('和')}`);
      });
      proxy.$router.go(-1);
    }
    ;
    const weatherData = reactive({
      infos: {
        win: "",
        //风向
        win_meter: "",
        //风速
        rain_pcpn: "",
        //降雨量
        tem: "" //实时温度
      },
      form: {
        cityid: "",
        //城市ID
        date: "",
        //当前日期
        week: "",
        //当前星期
        update_time: "",
        //气象台更新时间
        city: "",
        //城市名称
        cityEn: "",
        //城市英文名称
        country: "",
        //国家名称
        countryEn: "",
        //国家英文名称
        wea: "",
        //天气情况
        wea_img: "",
        //天气对应图标
        tem: "",
        //实时温度
        tem1: "",
        //高温
        tem2: "",
        //低温
        win: "",
        //风向
        win_speed: "",
        //风力等级
        win_meter: "",
        //风速
        humidity: "",
        //湿度
        visibility: "",
        //能见度
        pressure: "",
        //气压hPa
        rain_pcpn: "",
        //今日降雨量数值
        air: "",
        //空气质量
        air_level: "",
        //空气质量等级
        air_tips: "" //空气质量描述
      },
      alarm: {
        //气象预警
        alarm_type: "",
        //预警类型
        alarm_level: "",
        //预警级别
        alarm_content: "" //预警详细信息
      },
      aqi: {
        air: "",
        //空气质量
        air_level: "",
        //空气质量等级
        air_tips: "",
        //空气质量提示
        pm25: "",
        //PM2.5
        pm25_desc: "",
        //PM2.5等级描述
        pm10: "",
        //PM10
        pm10_desc: "",
        //PM10等级描述
        o3: "",
        //o3
        o3_desc: "",
        //o3等级描述
        no2: "",
        //no2
        no2_desc: "",
        //no2等级描述
        so2: "",
        //so2
        so2_desc: "",
        //so2等级描述
        kouzhao: "",
        //是否需要带口罩
        waichu: "",
        //外出适宜
        kaichuang: "",
        //开窗适宜
        jinghuaqi: "" //是否需要打开净化器
      }
    });
    const openWeatherInfo = ref(false);
    const showWeatherInfo = () => {
      refresh();
      openWeatherInfo.value = true;
    };
    function closeWeatherDialog() {
      weatherData.form = {};
      openWeatherInfo.value = false;
    }
    const refresh = () => {
      console.log(pageData.deviceInfo);
      if (pageData.deviceInfo.longitude === undefined || pageData.deviceInfo.latitude === undefined) {
        return;
      }
      weatherData.form = {};
      weatherData.alarm = {};
      weatherData.aqi = {};
      getWeather({
        longitude: pageData.deviceInfo.longitude,
        latitude: pageData.deviceInfo.latitude
      }).then(result => {
        console.log("天气数据");
        console.log(result);
        if (result.code === 200) {
          weatherData.form.win = result.data.day.wind;
          weatherData.form.cityid = result.data.cityid;
          weatherData.form.date = result.data.updateTimeFormat;
          weatherData.form.update_time = result.data.updateTimeFormat;
          weatherData.form.city = result.data.leader + "·" + result.data.city;
          weatherData.form.week = result.data.hours[0].dayOfWeek;
          weatherData.form.country = result.data.country;
          weatherData.form.wea = result.data.hours[0].wea;
          weatherData.form.wea_img = result.data.hours[0].wea_img;
          weatherData.form.tem = result.data.hours[0].tem + "°C";
          weatherData.form.tem1 = result.data.day.temperatureMaxSince7am + "°C";
          weatherData.form.tem2 = result.data.day.dewPoint + "°C";
          weatherData.form.win = result.data.hours[0].wind;
          weatherData.form.win_speed = result.data.hours[0].windLevel;
          weatherData.form.win_meter = result.data.hours[0].windSpeed + 'km/h';
          weatherData.form.humidity = result.data.hours[0].humidity;
          weatherData.form.visibility = result.data.hours[0].visibility;
          weatherData.form.pressure = result.data.hours[0].pressure;
          weatherData.form.rain_pcpn = result.data.hours[0].rain_pcpn + "mm";
          weatherData.form.air = result.data.hours[0].air;
          weatherData.form.air_level = result.data.day.aqi.air_level;
          weatherData.form.air_tips = result.data.day.aqi.air_tips;
          weatherData.aqi.air = result.data.day.aqi.air;
          weatherData.aqi.air_level = result.data.day.aqi.air_level;
          weatherData.aqi.air_tips = result.data.day.aqi.air_tips;
          weatherData.aqi.pm25 = result.data.day.aqi.pm25;
          weatherData.aqi.pm25_desc = result.data.day.aqi.pm25_desc;
          weatherData.aqi.pm10 = result.data.day.aqi.pm10;
          weatherData.aqi.pm10_desc = result.data.day.aqi.pm10_desc;
          weatherData.aqi.o3 = result.data.day.aqi.o3;
          weatherData.aqi.o3_desc = result.data.day.aqi.o3_desc;
          weatherData.aqi.no2 = result.data.day.aqi.no2;
          weatherData.aqi.no2_desc = result.data.day.aqi.no2_desc;
          weatherData.aqi.so2 = result.data.day.aqi.so2;
          weatherData.aqi.so2_desc = result.data.day.aqi.so2_desc;
          weatherData.aqi.kouzhao = result.data.day.aqi.kouzhao;
          weatherData.aqi.waichu = result.data.day.aqi.waichu;
          weatherData.aqi.kaichuang = result.data.day.aqi.kaichuang;
          weatherData.aqi.jinghuaqi = result.data.day.aqi.jinghuaqi;
        }
      }).catch(function (error) {
        //发生错误时的处理
        console.log(error);
      });
    };
    function getWeatherInfo(lng, lat) {
      if (lng === undefined || lat === undefined) {
        return;
      }
      getWeather({
        longitude: lng,
        latitude: lat
      }).then(result => {
        if (result.code === 200 && result.data.errcode === 0) {
          console.log("天气数据返回值");
          console.log(result);
          weatherData.infos.city = result.data.leader + "·" + result.data.city;
          weatherData.infos.date = result.data.updateTimeFormat;
          weatherData.infos.wea = result.data.hours[0].wea;
          weatherData.infos.tem = result.data.hours[0].tem + "°C";
          weatherData.infos.win = result.data.hours[0].wind;
          weatherData.infos.win_speed = result.data.hours[0].windLevel;
          weatherData.infos.win_meter = result.data.hours[0].windSpeed + 'km/h';
          weatherData.infos.humidity = result.data.hours[0].humidity;
          weatherData.infos.visibility = result.data.hours[0].visibility;
          weatherData.infos.rain_pcpn = result.data.hours[0].rain_pcpn + "mm";
          weatherData.infos.value.wea = result.data.hours[0].wea;
          weatherData.infos.value.winMeter = result.data.hours[0].windLevel;
          weatherData.infos.value.win = result.data.hours[0].wind;
        }
      });
    }
    ;
    const openPingResultInfo = ref(false);
    const targets = ref([]);
    const pingViewMode = ref('card');
    /**
     * 选中的IP地址
     * @type {import('vue').Ref<string>}
     */
    const selectedIp = ref('');

    /**
     * 选中的时间范围（分钟），0表示全部
     * @type {import('vue').Ref<number>}
     */
    const timeRange = ref(60);

    /**
     * 历史查询结果数据
     * @type {import('vue').Ref<Array>}
     */
    const historyResults = ref([]);
    /**
     * 统计数据（丢包率），key为IP地址
     * @type {import('vue').Ref<Object>}
     */
    const statsData = ref({});

    /**
     * 历史数据，key为IP地址，value为数组
     * @type {import('vue').Ref<Object>}
     */
    const historyData = ref({});

    /**
     * 最新ping结果，key为IP地址
     * @type {import('vue').Ref<Object>}
     */
    const latestResults = ref({});
    const getStatusClass = ip => {
      const result = latestResults.value[ip];
      if (!result) return 'status-unknown';
      return result.success ? 'status-online' : 'status-offline';
    };

    /**
     * 获取延迟显示的CSS类名
     * @param {string} ip - IP地址
     * @returns {string} CSS类名
     */
    const getLatencyClass = ip => {
      const result = latestResults.value[ip];
      if (!result || !result.success) return 'text-danger';
      return 'text-success';
    };

    /**
     * 获取延迟显示文本
     * @param {string} ip - IP地址
     * @returns {string} 延迟值或"超时"
     */
    const getLatencyDisplay = ip => {
      const result = latestResults.value[ip];
      if (!result) return '--';
      return result.success ? `${result.latency}ms` : '超时';
    };

    /**
     * 获取最近1分钟丢包率（前端计算）
     * @param {string} ip - IP地址
     * @returns {string} 丢包率百分比
     */
    const getPacketLoss1m = ip => {
      const history = historyData.value[ip];
      if (!history || history.length === 0) return 0;
      const last1m = history.slice(-60);
      const failed = last1m.filter(h => !h.success).length;
      return (failed / last1m.length * 100).toFixed(1);
    };

    /**
     * 获取总丢包率（从MQTT推送的统计数据获取）
     * @param {string} ip - IP地址
     * @returns {number} 丢包率百分比
     */
    const getPacketLoss = ip => {
      const stats = statsData.value[ip];
      return stats?.packetLoss ?? 0;
    };

    /**
     * 获取最近1分钟的历史数据用于图表显示
     * @param {string} ip - IP地址
     * @returns {Array} 最近60条数据
     */
    const getLast1MinData = ip => {
      const history = historyData.value[ip];
      if (!history || history.length === 0) return [];
      return history.slice(-60);
    };
    const showPingResultInfo = () => {
      openPingResultInfo.value = true;
    };

    // 闪烁状态
    const isPinging = ref(false);
    let pingTimer = null;

    /**
     * 检查吊舱视频是否丢包
     * @returns {boolean} 是否丢包
     */
    const isPodVideoLoss = () => {
      const podVideoTarget = targets.value.find(target => target.name === '吊舱视频');
      if (!podVideoTarget) return false;
      const ip = podVideoTarget.ip;
      // 只检查最新的 ping 结果是否失败
      const latestResult = latestResults.value[ip];
      const isLoss = latestResult && !latestResult.success;
      if (isLoss) {
        // 当检测到丢包时，触发或重置闪烁
        if (!isPinging.value) {
          isPinging.value = true;
        }

        // 重置3秒计时器
        if (pingTimer) {
          clearTimeout(pingTimer);
        }
        pingTimer = setTimeout(() => {
          // 3秒后停止闪烁，无论当前是否有丢包
          isPinging.value = false;
          pingTimer = null;
        }, 3000);
      }
      return isPinging.value;
    };

    /**
     * 获取平均延迟（基于所有历史数据）
     * @param {string} ip - IP地址
     * @returns {string} 平均延迟值
     */
    const getAvgLatency = ip => {
      const history = historyData.value[ip];
      if (!history || history.length === 0) return '--';
      const validData = history.filter(h => h.success && h.latency != null);
      if (validData.length === 0) return '--';
      const sum = validData.reduce((acc, h) => acc + h.latency, 0);
      return Math.round(sum / validData.length);
    };
    const setTargets = device => {
      if (device !== null) {
        let ips = [];
        let resultTopic = "ping/result/" + recentlyTaskId.value + "/";
        let statsTopic = "ping/stats/" + recentlyTaskId.value + "/";
        let satelliteMasterStation = device.satelliteMasterStation;
        let satelliteGateway = device.satelliteGateway;
        let flightControlLine = device.flightControlLine;
        let podControl = device.podControl;
        let podVideo = device.podVideo;
        if (satelliteMasterStation !== null && satelliteMasterStation !== undefined && satelliteMasterStation !== "") {
          ips.push({
            name: '卫星主站',
            ip: satelliteMasterStation
          });
          client.subscribe(resultTopic + satelliteMasterStation, {
            qos: 2
          }, () => {
            console.log(`订阅了卫星主站ping结果: ` + resultTopic + satelliteMasterStation);
          });
          client.subscribe(statsTopic + satelliteMasterStation, {
            qos: 2
          }, () => {
            console.log(`订阅了卫星主站统计数据: ` + statsTopic + satelliteMasterStation);
          });
        }
        if (satelliteGateway !== null && satelliteGateway !== undefined && satelliteGateway !== "") {
          ips.push({
            name: '卫通网关',
            ip: satelliteGateway
          });
          client.subscribe(resultTopic + satelliteGateway, {
            qos: 2
          }, () => {
            console.log(`订阅了卫通网关ping结果: ` + resultTopic + satelliteGateway);
          });
          client.subscribe(statsTopic + satelliteGateway, {
            qos: 2
          }, () => {
            console.log(`订阅了卫通网关统计数据: ` + statsTopic + satelliteGateway);
          });
        }
        if (flightControlLine !== null && flightControlLine !== undefined && flightControlLine !== "") {
          ips.push({
            name: '飞控专线',
            ip: flightControlLine
          });
          client.subscribe(resultTopic + flightControlLine, {
            qos: 2
          }, () => {
            console.log(`订阅了飞控专线ping结果: ` + resultTopic + flightControlLine);
          });
          client.subscribe(statsTopic + flightControlLine, {
            qos: 2
          }, () => {
            console.log(`订阅了飞控专线统计数据: ` + statsTopic + flightControlLine);
          });
        }
        if (podControl !== null && podControl !== undefined && podControl !== "") {
          ips.push({
            name: '吊舱控制',
            ip: podControl
          });
          client.subscribe(resultTopic + podControl, {
            qos: 2
          }, () => {
            console.log(`订阅了吊舱控制ping结果: ` + resultTopic + podControl);
          });
          client.subscribe(statsTopic + podControl, {
            qos: 2
          }, () => {
            console.log(`订阅了吊舱控制统计数据: ` + statsTopic + podControl);
          });
        }
        if (podVideo !== null && podVideo !== undefined && podVideo !== "") {
          ips.push({
            name: '吊舱视频',
            ip: podVideo
          });
          client.subscribe(resultTopic + podVideo, {
            qos: 2
          }, () => {
            console.log(`订阅了吊舱视频ping结果: ` + resultTopic + podVideo);
          });
          client.subscribe(statsTopic + podVideo, {
            qos: 2
          }, () => {
            console.log(`订阅了吊舱视频统计数据: ` + statsTopic + podVideo);
          });
        }
        targets.value = ips;
      }
    };

    /**
     * 处理收到的ping结果消息
     * @param {string} msg - MQTT消息内容
     * @param {string} topic - MQTT主题
     */
    const handlePingMessage = (msg, topic) => {
      try {
        const data = JSON.parse(msg);
        const topicParts = topic.split('/');
        const ip = topicParts[topicParts.length - 1];
        latestResults.value = {
          ...latestResults.value,
          [ip]: data
        };
        if (!historyData.value[ip]) {
          historyData.value = {
            ...historyData.value,
            [ip]: []
          };
        }
        const newHistory = [...historyData.value[ip], {
          latency: data.latency,
          success: data.success,
          timestamp: data.createdAt
        }];
        // 最多保留60s数据
        if (newHistory.length > 60) {
          newHistory.shift();
        }
        historyData.value = {
          ...historyData.value,
          [ip]: newHistory
        };
      } catch (e) {
        console.error('Error handling ping message:', e);
      }
    };

    /**
     * 处理收到的统计数据消息
     * @param {string} msg - MQTT消息内容
     * @param {string} topic - MQTT主题
     */
    const handleStatsMessage = (msg, topic) => {
      try {
        const data = JSON.parse(msg);
        const topicParts = topic.split('/');
        const ip = topicParts[topicParts.length - 1];
        statsData.value = {
          ...statsData.value,
          [ip]: data
        };
      } catch (e) {
        console.error('Error handling stats message:', e);
      }
    };
    const queryHistory = () => {
      if (selectedIp.value !== '' && selectedIp.value !== null && selectedIp.value !== undefined) {
        getHistoryPingResult({
          ip: selectedIp.value,
          minutes: timeRange.value
        }).then(res => {
          historyResults.value = res;
        });
      }
    };
    const getCurrentName = ip => {
      return targets.value.find(item => item.ip === ip)?.name;
    };

    /**
     * 过滤出成功的ping结果（用于计算延迟统计）
     * @type {import('vue').ComputedRef<Array>}
     */
    const validResults = computed(() => historyResults.value.filter(r => r.success && r.latency != null));

    /**
     * 计算平均延迟
     * @type {import('vue').ComputedRef<number>}
     */
    const avgLatency = computed(() => {
      if (validResults.value.length === 0) return 0;
      const sum = validResults.value.reduce((acc, r) => acc + r.latency, 0);
      return Math.round(sum / validResults.value.length);
    });

    /**
     * 计算最大延迟
     * @type {import('vue').ComputedRef<number>}
     */
    const maxLatency = computed(() => {
      if (validResults.value.length === 0) return 0;
      return Math.max(...validResults.value.map(r => r.latency));
    });

    /**
     * 计算最小延迟
     * @type {import('vue').ComputedRef<number>}
     */
    const minLatency = computed(() => {
      if (validResults.value.length === 0) return 0;
      return Math.min(...validResults.value.map(r => r.latency));
    });

    /**
     * 计算丢包率
     * @type {import('vue').ComputedRef<string>}
     */
    const packetLoss = computed(() => {
      if (historyResults.value.length === 0) return 0;
      const failed = historyResults.value.filter(r => !r.success).length;
      return (failed / historyResults.value.length * 100).toFixed(1);
    });
    const closePingResultDialog = () => {
      openPingResultInfo.value = false;
    };
    const handleFullScreen = () => {
      if (screenfull.isEnabled) {
        if (screenfull.isFullscreen) {
          screenfull.toggle();
          fullscreen.value = false;
          // screenfull.exit()
        } else {
          // 进入全屏
          screenfull.toggle();
          fullscreen.value = true;
          // screenfull.request()
        }
      } else {
        proxy.$modal.msgWarning('提示：不支持切换全屏。');
      }
    };
    function showFourSplitFullscreen() {
      showFourSplit.value = true;
      setTimeout(() => {
        requestAnimationFrame(() => {
          const dom = document.getElementsByClassName("split_four")[0];
          if (screenfull.isEnabled) {
            screenfull.request(dom);
          }
        });
      }, 50);
    }
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_tooltip = _resolveComponent("el-tooltip");
      const _component_svg_icon = __unplugin_components_0;
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_progress = _resolveComponent("el-progress");
      const _component_el_table = _resolveComponent("el-table");
      const _component_pagination = __unplugin_components_1;
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _component_el_tree = _resolveComponent("el-tree");
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_divider = _resolveComponent("el-divider");
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_radio_button = _resolveComponent("el-radio-button");
      const _component_el_radio_group = _resolveComponent("el-radio-group");
      const _component_el_empty = _resolveComponent("el-empty");
      const _directive_hasPermi = _resolveDirective("hasPermi");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_unref(spilt) !== 3 ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_unref(oneName)), 1)) : _createCommentVNode("", true), _unref(spilt) === 0 ? (_openBlock(), _createBlock(_component_el_tooltip, {
        key: 1,
        content: "四宫格全屏",
        placement: "top",
        "auto-close": 500
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: showFourSplitFullscreen,
          class: "satpro-button fullscreen_btn",
          link: "",
          icon: "Menu"
        })]),
        _: 1
      })) : _createCommentVNode("", true), _createVNode(_component_el_tooltip, {
        content: _unref(fullscreen) ? '退出全屏' : '全屏',
        placement: "top",
        "auto-close": 500
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: handleFullScreen,
          class: "satpro-button fullscreen_button",
          link: ""
        }, {
          default: _withCtx(() => [_createVNode(_component_svg_icon, {
            "icon-class": _unref(fullscreen) ? 'exit-fullscreen' : 'fullscreen'
          }, null, 8, ["icon-class"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["content"]), _createVNode(_component_el_tooltip, {
        content: "返回",
        placement: "top",
        "auto-close": 500
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: goBack,
          class: "satpro-button back_button",
          link: "",
          icon: "Back"
        })]),
        _: 1
      }), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", {
        class: "menu_item",
        onClick: _cache[0] || (_cache[0] = $event => _unref(permission).setTalkShow(true))
      }, [...(_cache[22] || (_cache[22] = [_createElementVNode("img", {
        src: _imports_0,
        alt: ""
      }, null, -1), _createElementVNode("span", null, "语音", -1)]))]), _createElementVNode("div", {
        class: "menu_item",
        onClick: showTasks
      }, [...(_cache[23] || (_cache[23] = [_createElementVNode("img", {
        src: _imports_1,
        alt: ""
      }, null, -1), _createElementVNode("span", null, "历史任务", -1)]))]), _createElementVNode("div", {
        class: "menu_item",
        onClick: showDevices
      }, [...(_cache[24] || (_cache[24] = [_createElementVNode("img", {
        src: _imports_2,
        alt: ""
      }, null, -1), _createElementVNode("span", null, "实时信息", -1)]))]), _unref(isShowButton) ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "menu_item",
        onClick: showUsers
      }, [...(_cache[25] || (_cache[25] = [_createElementVNode("img", {
        src: _imports_3,
        alt: ""
      }, null, -1), _createElementVNode("span", null, "任务信息", -1)]))])) : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: "menu_item",
        onClick: showUsers
      }, [...(_cache[26] || (_cache[26] = [_createElementVNode("img", {
        src: _imports_3,
        alt: ""
      }, null, -1), _createElementVNode("span", null, "设备信息", -1)]))])), _unref(isShowButton) ? (_openBlock(), _createElementBlock("div", {
        key: 2,
        class: "menu_item",
        onClick: showALarmDetail
      }, [...(_cache[27] || (_cache[27] = [_createElementVNode("img", {
        src: _imports_4,
        alt: ""
      }, null, -1), _createElementVNode("span", null, "告警信息", -1)]))])) : _createCommentVNode("", true), _unref(isShowButton) ? (_openBlock(), _createElementBlock("div", {
        key: 3,
        class: "menu_item",
        onClick: showStatistic
      }, [...(_cache[28] || (_cache[28] = [_createElementVNode("img", {
        src: _imports_5,
        alt: ""
      }, null, -1), _createElementVNode("span", null, "统计信息", -1)]))])) : _createCommentVNode("", true), _unref(isTasking) ? (_openBlock(), _createElementBlock("div", {
        key: 4,
        class: "menu_item",
        onClick: showWeatherInfo
      }, [...(_cache[29] || (_cache[29] = [_createElementVNode("img", {
        src: _imports_6,
        alt: ""
      }, null, -1), _createElementVNode("span", null, "气象信息", -1)]))])) : _createCommentVNode("", true), _unref(isTasking) && _unref(isShowButton) ? (_openBlock(), _createElementBlock("div", {
        key: 5,
        class: _normalizeClass(["menu_item", {
          'ping-warning': isPodVideoLoss()
        }]),
        onClick: showPingResultInfo
      }, [...(_cache[30] || (_cache[30] = [_createElementVNode("img", {
        src: _imports_5,
        alt: ""
      }, null, -1), _createElementVNode("span", null, "链路状态", -1)]))], 2)) : _createCommentVNode("", true)]), _unref(spilt) === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createVNode(_unref(pop), {
        onDownloadMp4: downloadMp4,
        onDownloadProgressFormat: downloadProgressFormat,
        isTasking: _unref(isTasking)
      }, null, 8, ["isTasking"])]), _createElementVNode("div", _hoisted_7, [_createVNode(_unref(car), {
        weatherData: _unref(weatherData),
        isTasking: _unref(isTasking)
      }, null, 8, ["weatherData", "isTasking"])]), _createElementVNode("div", _hoisted_8, [_createVNode(_unref(control), {
        isTasking: _unref(isTasking)
      }, null, 8, ["isTasking"])]), _createElementVNode("div", _hoisted_9, [_createVNode(_unref(tmap), {
        ref: "taskMapRef",
        mapVideo: _unref(mapVideo)
      }, null, 8, ["mapVideo"])])])])) : _createCommentVNode("", true), false ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createVNode(_unref(control), {
        isTasking: _unref(isTasking)
      }, null, 8, ["isTasking"])]), _createElementVNode("div", _hoisted_13, [_createVNode(_unref(tmap), {
        ref: "taskMapRef",
        mapVideo: _unref(mapVideo)
      }, null, 8, ["mapVideo"])])]), _unref(spilt) === 1 ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createVNode(_unref(car), {
        weatherData: _unref(weatherData),
        isTasking: _unref(isTasking)
      }, null, 8, ["weatherData", "isTasking"])])])) : _createCommentVNode("", true), _unref(spilt) === 2 ? (_openBlock(), _createElementBlock("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_createVNode(_unref(pop), {
        isTasking: _unref(isTasking)
      }, null, 8, ["isTasking"])])])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _unref(spilt) === 3 ? (_openBlock(), _createElementBlock("div", _hoisted_18, [_createElementVNode("div", {
        class: _normalizeClass(_unref(pageData).taskPlay)
      }, [!_unref(pageData).buttonShow ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(_unref(pageData).showMin ? 'talkButtonClass1' : 'talkButtonClass2')
      }, [_createVNode(ViewerButton)], 2)) : _createCommentVNode("", true), _createVNode(_unref(onevideo), {
        ref: "oneVideoRef",
        isTasking: _unref(isTasking),
        oneName: _unref(oneName),
        oneVideo: _unref(oneVideo),
        onDownloadProgressFormat: downloadProgressFormat,
        onDownloadMp4: downloadMp4
      }, null, 8, ["isTasking", "oneName", "oneVideo"])], 2), _createElementVNode("div", {
        class: _normalizeClass(_unref(pageData).viewerClass)
      }, [_unref(pageData).buttonShow ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(_unref(pageData).showMin ? 'talkButtonClass1' : 'talkButtonClass2')
      }, [_createVNode(ViewerButton)], 2)) : _createCommentVNode("", true), _createVNode(_unref(tmap), {
        ref: "taskMapRef",
        mapVideo: _unref(mapVideo),
        spilt: _unref(spilt),
        oneName: _unref(oneName),
        showSubtitle: _unref(isShowButton),
        showSwitch: _unref(isShowButton)
      }, null, 8, ["mapVideo", "spilt", "oneName", "showSubtitle", "showSwitch"])], 2)])) : _createCommentVNode("", true), _unref(rightMenuIsShow) ? (_openBlock(), _createElementBlock("div", _hoisted_19, [_createElementVNode("div", {
        class: _normalizeClass(["menu-item", {
          active: _unref(spilt) === 0
        }]),
        onClick: _cache[1] || (_cache[1] = $event => switchViews(0))
      }, "默认视图", 2), false ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["menu-item", {
          active: _unref(spilt) === 1
        }]),
        onClick: _cache[2] || (_cache[2] = $event => switchViews(1))
      }, "起降视图", 2)) : _createCommentVNode("", true), false ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: _normalizeClass(["menu-item", {
          active: _unref(spilt) === 2
        }]),
        onClick: _cache[3] || (_cache[3] = $event => switchViews(2))
      }, "飞行视图", 2)) : _createCommentVNode("", true), _createElementVNode("div", {
        class: _normalizeClass(["menu-item", {
          active: _unref(spilt) === 3
        }]),
        onClick: _cache[4] || (_cache[4] = $event => switchViews(3))
      }, "任务视图", 2)])) : _createCommentVNode("", true), _createVNode(_component_el_dialog, {
        title: "历史任务",
        modelValue: _unref(openTask),
        "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => _isRef(openTask) ? openTask.value = $event : null),
        width: "120rem",
        "close-on-click-modal": false,
        "append-to-body": "",
        draggable: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form, {
          model: _unref(queryParams),
          ref: "queryRef",
          inline: true
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "任务时间",
            style: {
              "width": "41rem"
            }
          }, {
            default: _withCtx(() => [_createVNode(_unref(DatePicker), {
              ref: "datePickerRef",
              onSetDateRange: setDateRange
            }, null, 512)]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "任务名称",
            prop: "taskName",
            style: {
              "width": "18rem"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(queryParams).taskName,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _unref(queryParams).taskName = $event),
              placeholder: "请输入任务名称",
              clearable: "",
              onKeyup: _withKeys(handleQuery, ["enter"])
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "状态",
            prop: "taskStatus"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: _unref(queryParams).taskStatus,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => _unref(queryParams).taskStatus = $event),
              placeholder: "状态",
              clearable: "",
              style: {
                "width": "18rem"
              }
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(task_status), dict => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: dict.value,
                  label: dict.label,
                  value: dict.value
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              class: "satpro-button",
              icon: "Search",
              onClick: handleQuery
            }, {
              default: _withCtx(() => [...(_cache[31] || (_cache[31] = [_createTextVNode("搜索", -1)]))]),
              _: 1
            }), _createVNode(_component_el_button, {
              class: "satpro-button",
              icon: "Refresh",
              onClick: resetQuery
            }, {
              default: _withCtx(() => [...(_cache[32] || (_cache[32] = [_createTextVNode("重置", -1)]))]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"]), _createElementVNode("div", _hoisted_20, [_createVNode(_component_el_table, {
          onRowClick: clickRow,
          data: _unref(historyTasks),
          "header-cell-style": {
            background: 'transparent !important',
            color: '#FFFFFF'
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            label: "编号",
            align: "center",
            key: "taskId",
            prop: "taskId"
          }), _createVNode(_component_el_table_column, {
            label: "名称",
            align: "center",
            key: "taskName",
            prop: "taskName",
            "show-overflow-tooltip": true
          }), _createVNode(_component_el_table_column, {
            label: "批次",
            align: "center",
            key: "taskTimes",
            prop: "taskTimes",
            formatter: taskTimesFormat
          }), _createVNode(_component_el_table_column, {
            label: "开始时间",
            align: "center",
            prop: "taskStarttime",
            width: "100"
          }, {
            default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(_ctx.parseTime(scope.row.taskStarttime, '{h}:{i}:{s}')), 1)]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "结束时间",
            align: "center",
            prop: "taskEndtime",
            width: "100"
          }, {
            default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(_ctx.parseTime(scope.row.taskEndtime, '{h}:{i}:{s}')), 1)]),
            _: 1
          }), _unref(pageData).deviceInfo.deviceType !== '3' ? (_openBlock(), _createBlock(_component_el_table_column, {
            key: 0,
            label: "进度",
            align: "center",
            prop: "percentage",
            width: "160"
          }, {
            default: _withCtx(scope => [_createVNode(_component_el_progress, {
              "text-inside": true,
              "stroke-width": 24,
              percentage: scope.row.percentage,
              status: "success"
            }, null, 8, ["percentage"])]),
            _: 1
          })) : _createCommentVNode("", true), _createVNode(_component_el_table_column, {
            label: "时长(s)",
            align: "center",
            key: "taskDuration",
            prop: "taskDuration",
            width: "90"
          }, {
            default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(scope.row.taskDuration === undefined ? "" : _ctx.getTime(scope.row.taskDuration)), 1)]),
            _: 1
          }), _withDirectives((_openBlock(), _createBlock(_component_el_table_column, {
            label: "下载",
            align: "center",
            key: "taskDownload"
          }, {
            default: _withCtx(scope => [_cache[39] || (_cache[39] = _createElementVNode("div", {
              style: {
                "width": "200px"
              }
            }, null, -1)), _unref(permission).downloadMp4Ready.indexOf(scope.row.taskName + 'pod') !== -1 ? (_openBlock(), _createBlock(_component_el_tooltip, {
              key: 0,
              content: "后台已准备完成，若没开始下载请点击",
              placement: "top"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_button, {
                type: "success",
                onClick: _withModifiers($event => downloadMp4ByTask(scope.row), ["stop"])
              }, {
                default: _withCtx(() => [...(_cache[33] || (_cache[33] = [_createTextVNode("录像", -1)]))]),
                _: 1
              }, 8, ["onClick"])]),
              _: 2
            }, 1024)) : _unref(permission).downloadMp4.indexOf(scope.row.taskName + 'pod') !== -1 ? (_openBlock(), _createBlock(_component_el_tooltip, {
              key: 1,
              content: "后台正在准备视频，请稍后",
              placement: "top"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_button, {
                type: "primary",
                loading: "",
                onClick: _withModifiers($event => downloadMp4ByTask(scope.row), ["stop"])
              }, {
                default: _withCtx(() => [...(_cache[34] || (_cache[34] = [_createTextVNode("录像", -1)]))]),
                _: 1
              }, 8, ["onClick"])]),
              _: 2
            }, 1024)) : (_openBlock(), _createBlock(_component_el_tooltip, {
              key: 2,
              content: "点击下载录像",
              placement: "top"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_button, {
                onClick: _withModifiers($event => downloadMp4ByTask(scope.row), ["stop"])
              }, {
                default: _withCtx(() => [...(_cache[35] || (_cache[35] = [_createTextVNode("录像", -1)]))]),
                _: 1
              }, 8, ["onClick"])]),
              _: 2
            }, 1024)), _unref(pageData).deviceInfo.deviceType === '3' ? (_openBlock(), _createBlock(_component_el_tooltip, {
              key: 3,
              content: "点击下载数据",
              placement: "top"
            }, {
              default: _withCtx(() => [_unref(permission).downloadDatReady.indexOf(scope.row.taskId) !== -1 ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                type: "success",
                onClick: _withModifiers($event => downloadTxtByTask(scope.row), ["stop"])
              }, {
                default: _withCtx(() => [...(_cache[36] || (_cache[36] = [_createTextVNode("数据", -1)]))]),
                _: 1
              }, 8, ["onClick"])) : _unref(permission).downloadDatNon.indexOf(scope.row.taskId) !== -1 ? (_openBlock(), _createBlock(_component_el_button, {
                key: 1,
                type: "info",
                onClick: _withModifiers($event => downloadTxtByTask(scope.row), ["stop"])
              }, {
                default: _withCtx(() => [...(_cache[37] || (_cache[37] = [_createTextVNode("数据", -1)]))]),
                _: 1
              }, 8, ["onClick"])) : (_openBlock(), _createBlock(_component_el_button, {
                key: 2,
                onClick: _withModifiers($event => downloadTxtByTask(scope.row), ["stop"])
              }, {
                default: _withCtx(() => [...(_cache[38] || (_cache[38] = [_createTextVNode("数据", -1)]))]),
                _: 1
              }, 8, ["onClick"]))]),
              _: 2
            }, 1024)) : _createCommentVNode("", true)]),
            _: 1
          })), [[_directive_hasPermi, ['drone:task:download']]])]),
          _: 1
        }, 8, ["data"]), _withDirectives(_createVNode(_component_pagination, {
          total: _unref(total),
          page: _unref(queryParams).pageNum,
          "onUpdate:page": _cache[7] || (_cache[7] = $event => _unref(queryParams).pageNum = $event),
          limit: _unref(queryParams).pageSize,
          "onUpdate:limit": _cache[8] || (_cache[8] = $event => _unref(queryParams).pageSize = $event),
          onPagination: getHistoryTaskList
        }, null, 8, ["total", "page", "limit"]), [[_vShow, _unref(total) > 0]])])]),
        _: 1
      }, 8, ["modelValue"]), _unref(openDevice) ? (_openBlock(), _createBlock(_component_el_dialog, {
        key: 6,
        title: "实时信息",
        modelValue: _unref(openDevice),
        "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => _isRef(openDevice) ? openDevice.value = $event : null),
        width: "140rem",
        "close-on-click-modal": false,
        "append-to-body": "",
        "before-close": closeDialog,
        draggable: ""
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_21, [_createVNode(_component_el_row, {
          gutter: 20
        }, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 4,
            xs: 24
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_22, [_unref(openDevice) ? (_openBlock(), _createBlock(_component_el_tree, {
              key: 0,
              class: "tree-border",
              data: _unref(treeselectDevice),
              ref: "menuRef",
              "node-key": "id",
              "default-expand-all": "",
              "expand-on-click-node": false,
              "empty-text": "加载中，请稍候",
              props: {
                label: 'label',
                children: 'children'
              },
              onNodeClick: handleNodeClickRealTime
            }, null, 8, ["data"])) : _createCommentVNode("", true)])]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 20,
            xs: 24
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_23, [_createVNode(_component_el_form, {
              "label-width": "20rem",
              class: "edit-file"
            }, {
              default: _withCtx(() => [_unref(airSatcomStatus) && !_unref(airSatcomKa) ? (_openBlock(), _createBlock(_component_el_row, {
                key: 0
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(satcomDataTableColumn), item => {
                  return _openBlock(), _createBlock(_component_el_col, {
                    key: item.id,
                    span: 12
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_form_item, {
                      label: item.columnNameZh + '：'
                    }, {
                      default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(item.value) + " " + _toDisplayString(item.columnNameUnit), 1), item.numToStatus === 1 ? (_openBlock(), _createElementBlock("span", _hoisted_24, "（" + _toDisplayString(item.stringStatusMap[item.value]) + "）", 1)) : _createCommentVNode("", true)]),
                      _: 2
                    }, 1032, ["label"])]),
                    _: 2
                  }, 1024);
                }), 128)), _createVNode(_component_el_divider)]),
                _: 1
              })) : _createCommentVNode("", true), _unref(airSatcomStatus) && _unref(airSatcomKa) ? (_openBlock(), _createBlock(_component_el_row, {
                key: 1
              }, {
                default: _withCtx(() => [_createVNode(_component_el_col, null, {
                  default: _withCtx(() => [...(_cache[40] || (_cache[40] = [_createElementVNode("h3", {
                    style: {
                      "margin": "0.8rem",
                      "color": "#48D1CC"
                    }
                  }, "信号强度:", -1)]))]),
                  _: 1
                }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(signalTableColumn), item => {
                  return _openBlock(), _createBlock(_component_el_col, {
                    key: item.id,
                    span: 12
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_form_item, {
                      label: item.columnNameZh + '：'
                    }, {
                      default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(item.value) + " " + _toDisplayString(item.columnNameUnit), 1), item.numToStatus === 1 ? (_openBlock(), _createElementBlock("span", _hoisted_25, "（" + _toDisplayString(item.stringStatusMap[item.value]) + "）", 1)) : _createCommentVNode("", true)]),
                      _: 2
                    }, 1032, ["label"])]),
                    _: 2
                  }, 1024);
                }), 128)), _createVNode(_component_el_col, null, {
                  default: _withCtx(() => [...(_cache[41] || (_cache[41] = [_createElementVNode("h3", {
                    style: {
                      "margin": "0.8rem",
                      "color": "#48D1CC"
                    }
                  }, "波束信息:", -1)]))]),
                  _: 1
                }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(beamTableColumn), item => {
                  return _openBlock(), _createBlock(_component_el_col, {
                    key: item.id,
                    span: 12
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_form_item, {
                      label: item.columnNameZh + '：'
                    }, {
                      default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(item.value) + " " + _toDisplayString(item.columnNameUnit), 1), item.numToStatus === 1 ? (_openBlock(), _createElementBlock("span", _hoisted_26, "（" + _toDisplayString(item.stringStatusMap[item.value]) + "）", 1)) : _createCommentVNode("", true)]),
                      _: 2
                    }, 1032, ["label"])]),
                    _: 2
                  }, 1024);
                }), 128)), _createVNode(_component_el_col, null, {
                  default: _withCtx(() => [...(_cache[42] || (_cache[42] = [_createElementVNode("h3", {
                    style: {
                      "margin": "0.8rem",
                      "color": "#48D1CC"
                    }
                  }, "设备入网状态:", -1)]))]),
                  _: 1
                }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(networkTableColumn), item => {
                  return _openBlock(), _createBlock(_component_el_col, {
                    key: item.id,
                    span: 12
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_form_item, {
                      label: item.columnNameZh + '：'
                    }, {
                      default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(item.value) + " " + _toDisplayString(item.columnNameUnit), 1), item.numToStatus === 1 ? (_openBlock(), _createElementBlock("span", _hoisted_27, "（" + _toDisplayString(item.stringStatusMap[item.value]) + "）", 1)) : _createCommentVNode("", true)]),
                      _: 2
                    }, 1032, ["label"])]),
                    _: 2
                  }, 1024);
                }), 128)), _createVNode(_component_el_divider)]),
                _: 1
              })) : _createCommentVNode("", true), _unref(formingView) && _unref(formingView).length > 0 ? (_openBlock(), _createBlock(_component_el_row, {
                key: 2
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(formingView), item => {
                  return _openBlock(), _createBlock(_component_el_col, {
                    key: item.id,
                    span: 12
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_form_item, {
                      label: item.columnNameZh + '：'
                    }, {
                      default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(item.value) + " " + _toDisplayString(item.columnNameUnit), 1), item.numToStatus === 1 ? (_openBlock(), _createElementBlock("span", _hoisted_28, "（" + _toDisplayString(item.stringStatusMap[item.value]) + "）", 1)) : _createCommentVNode("", true)]),
                      _: 2
                    }, 1032, ["label"])]),
                    _: 2
                  }, 1024);
                }), 128))]),
                _: 1
              })) : (_openBlock(), _createElementBlock("div", _hoisted_29, [...(_cache[43] || (_cache[43] = [_createElementVNode("span", null, "暂无数据", -1)]))])), _cache[44] || (_cache[44] = _createElementVNode("br", {
                class: "clear",
                style: {
                  "clear": "both"
                }
              }, null, -1))]),
              _: 1
            })])]),
            _: 1
          })]),
          _: 1
        })])]),
        _: 1
      }, 8, ["modelValue"])) : _createCommentVNode("", true), _unref(openUser) ? (_openBlock(), _createBlock(_component_el_dialog, {
        key: 7,
        title: _unref(isShowButton) ? '任务信息' : '设备信息',
        modelValue: _unref(openUser),
        "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => _isRef(openUser) ? openUser.value = $event : null),
        width: "120rem",
        "close-on-click-modal": false,
        "append-to-body": "",
        "before-close": closeDialog,
        draggable: ""
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_30, [_createVNode(_component_el_row, {
          gutter: 20
        }, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 4,
            xs: 24
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_31, [_unref(openUser) ? (_openBlock(), _createBlock(_component_el_tree, {
              key: 0,
              class: "tree-border",
              data: _unref(treeselectDevice),
              ref: "menuRef",
              "node-key": "id",
              "default-expand-all": "",
              "expand-on-click-node": false,
              "empty-text": "加载中，请稍候",
              props: {
                label: 'label',
                children: 'children'
              },
              onNodeClick: handleNodeClickInvariant
            }, null, 8, ["data"])) : _createCommentVNode("", true)])]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 20,
            xs: 24
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_32, [_unref(formview) ? (_openBlock(), _createBlock(_component_el_form, {
              key: 0,
              ref: "formviewRef",
              model: _unref(formview),
              "label-width": "20rem",
              class: "edit-file"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_row, null, {
                default: _withCtx(() => [_createVNode(_component_el_col, {
                  span: 12
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_form_item, {
                    label: "设备名称",
                    prop: "name"
                  }, {
                    default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(formview).name), 1)]),
                    _: 1
                  })]),
                  _: 1
                }), _createVNode(_component_el_col, {
                  span: 12
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_form_item, {
                    label: "归属部门",
                    prop: "deptName"
                  }, {
                    default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(formview).deptName), 1)]),
                    _: 1
                  })]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_el_row, null, {
                default: _withCtx(() => [_createVNode(_component_el_col, {
                  span: 12
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_form_item, {
                    label: "经纬度"
                  }, {
                    default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(formview).longitude) + "     " + _toDisplayString(_unref(formview).latitude), 1)]),
                    _: 1
                  })]),
                  _: 1
                }), _createVNode(_component_el_col, {
                  span: 12
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_form_item, {
                    label: "高程（米）"
                  }, {
                    default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(formview).highly), 1)]),
                    _: 1
                  })]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_el_row, null, {
                default: _withCtx(() => [_createVNode(_component_el_col, {
                  span: 12
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_form_item, {
                    label: "UID",
                    prop: "uid"
                  }, {
                    default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(formview).uid), 1)]),
                    _: 1
                  })]),
                  _: 1
                }), _createVNode(_component_el_col, {
                  span: 12
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_form_item, {
                    label: "设备负责人",
                    prop: "ownerUserName"
                  }, {
                    default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(formview).ownerUserName), 1)]),
                    _: 1
                  })]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_el_row, null, {
                default: _withCtx(() => [_createVNode(_component_el_col, {
                  span: 12
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_form_item, {
                    label: "生产时间",
                    prop: "productionTime"
                  }, {
                    default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(formview).productionTime), 1)]),
                    _: 1
                  })]),
                  _: 1
                }), _createVNode(_component_el_col, {
                  span: 12
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_form_item, {
                    label: "到期时间",
                    prop: "expirationTime"
                  }, {
                    default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(formview).expirationTime), 1)]),
                    _: 1
                  })]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_el_row, null, {
                default: _withCtx(() => [_createVNode(_component_el_col, {
                  span: 12
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_form_item, {
                    label: "联系方式",
                    prop: "phoneNumber"
                  }, {
                    default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(formview).phoneNumber), 1)]),
                    _: 1
                  })]),
                  _: 1
                }), _createVNode(_component_el_col, {
                  span: 12
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_form_item, {
                    label: "型号",
                    prop: "model"
                  }, {
                    default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(formview).model), 1)]),
                    _: 1
                  })]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_el_row, null, {
                default: _withCtx(() => [_createVNode(_component_el_col, {
                  span: 12
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_form_item, {
                    label: "设备编码",
                    prop: "deviceName"
                  }, {
                    default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(formview).deviceName), 1)]),
                    _: 1
                  })]),
                  _: 1
                }), _createVNode(_component_el_col, {
                  span: 12
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_form_item, {
                    label: "设备通道",
                    prop: "channelId"
                  }, {
                    default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(formview).channelId), 1)]),
                    _: 1
                  })]),
                  _: 1
                })]),
                _: 1
              }), _unref(formview).fieldTemplateList && _unref(formview).fieldTemplateList.length > 0 ? (_openBlock(), _createBlock(_component_el_row, {
                key: 0
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(formview).fieldTemplateList, item => {
                  return _openBlock(), _createBlock(_component_el_col, {
                    key: item.field,
                    required: item.required,
                    span: 12
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_form_item, {
                      label: item.label
                    }, {
                      default: _withCtx(() => [_withDirectives(_createElementVNode("span", null, _toDisplayString(item.value), 513), [[_vShow, item.type === 1 || item.type === 3 || item.type === 4]]), _withDirectives(_createElementVNode("span", null, _toDisplayString(item.value ? "是" : "否"), 513), [[_vShow, item.type === 2]]), _withDirectives(_createElementVNode("span", null, _toDisplayString(showItemLabel(item.type, item.map, item.value)), 513), [[_vShow, item.type === 5 || item.type === 6]])]),
                      _: 2
                    }, 1032, ["label"])]),
                    _: 2
                  }, 1032, ["required"]);
                }), 128))]),
                _: 1
              })) : _createCommentVNode("", true), _cache[45] || (_cache[45] = _createElementVNode("br", {
                class: "clear",
                style: {
                  "clear": "both"
                }
              }, null, -1)), _createVNode(_component_el_row, null, {
                default: _withCtx(() => [_createVNode(_component_el_col, {
                  span: 24
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_form_item, {
                    label: "备注",
                    prop: "remark"
                  }, {
                    default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(formview).remark), 1)]),
                    _: 1
                  })]),
                  _: 1
                })]),
                _: 1
              })]),
              _: 1
            }, 8, ["model"])) : (_openBlock(), _createBlock(_component_el_table, {
              key: 1,
              data: _unref(userList),
              "header-cell-style": {
                background: 'transparent !important',
                color: '#FFFFFF'
              }
            }, {
              default: _withCtx(() => [_createVNode(_component_el_table_column, {
                label: "人员",
                align: "center",
                key: "userName",
                prop: "userName"
              }), _createVNode(_component_el_table_column, {
                label: "岗位",
                align: "center",
                key: "postName",
                prop: "postName",
                "show-overflow-tooltip": true
              }), _createVNode(_component_el_table_column, {
                label: "部门",
                align: "center",
                key: "deptName",
                prop: "deptName"
              }), _createVNode(_component_el_table_column, {
                label: "手机号码",
                align: "center",
                key: "phonenumber",
                prop: "phonenumber"
              }), _createVNode(_component_el_table_column, {
                label: "邮箱",
                align: "center",
                key: "email",
                prop: "email"
              })]),
              _: 1
            }, 8, ["data"]))])]),
            _: 1
          })]),
          _: 1
        })])]),
        _: 1
      }, 8, ["title", "modelValue"])) : _createCommentVNode("", true), _unref(openAlarmDrtail) ? (_openBlock(), _createBlock(_component_el_dialog, {
        key: 8,
        title: "告警详情",
        modelValue: _unref(openAlarmDrtail),
        "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => _isRef(openAlarmDrtail) ? openAlarmDrtail.value = $event : null),
        style: {
          "width": "90vw",
          "height": "76rem"
        },
        "close-on-click-modal": false,
        onBeforeClose: _cache[13] || (_cache[13] = $event => closeAlarmDrtailDialog()),
        "append-to-body": "",
        draggable: ""
      }, {
        default: _withCtx(() => [_createVNode(AlarmDrtail)]),
        _: 1
      }, 8, ["modelValue"])) : _createCommentVNode("", true), _createVNode(_unref(statistic), {
        ref: "taskStatisticRef"
      }, null, 512), _createVNode(_component_el_dialog, {
        title: "天气信息",
        modelValue: _unref(openWeatherInfo),
        "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => _isRef(openWeatherInfo) ? openWeatherInfo.value = $event : null),
        width: "120rem",
        "close-on-click-modal": false,
        "append-to-body": "",
        onBeforeClose: _cache[16] || (_cache[16] = $event => closeWeatherDialog()),
        draggable: ""
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_33, [_createVNode(_component_el_tooltip, {
          effect: "dark",
          content: "更新",
          placement: "top",
          "auto-close": 500
        }, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            circle: "",
            icon: "Refresh",
            onClick: _cache[14] || (_cache[14] = $event => refresh()),
            class: "satpro-button update_button"
          })]),
          _: 1
        })]), _createElementVNode("div", _hoisted_34, [_createElementVNode("div", _hoisted_35, [_createVNode(_component_el_form, {
          "label-width": "14rem",
          class: "edit-file"
        }, {
          default: _withCtx(() => [_cache[46] || (_cache[46] = _createElementVNode("h3", {
            style: {
              "margin": "0.8rem",
              "color": "#48D1CC"
            }
          }, "基本信息:", -1)), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "城市ID"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(weatherData).form.cityid), 1)]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "当前日期"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(weatherData).form.date), 1)]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "当前星期"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(weatherData).form.week), 1)]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "气象台更新时间"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(weatherData).form.update_time), 1)]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "城市名称"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(weatherData).form.city), 1)]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "城市英文名称"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(weatherData).form.cityEn), 1)]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "国家名称"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(weatherData).form.country), 1)]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "国家英文名称"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(weatherData).form.countryEn), 1)]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "天气情况"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(weatherData).form.wea), 1)]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "天气对应图标"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(weatherData).form.wea_img), 1)]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "实时温度"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(weatherData).form.tem), 1)]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "高温"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(weatherData).form.tem1), 1)]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "低温"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(weatherData).form.tem2), 1)]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "风向"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(weatherData).form.win), 1)]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "风力等级"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(weatherData).form.win_speed), 1)]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "风速"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(weatherData).form.win_meter), 1)]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "湿度"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(weatherData).form.humidity), 1)]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "能见度"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(weatherData).form.visibility), 1)]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "气压hPa"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(weatherData).form.pressure), 1)]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "今日降雨量数值"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(weatherData).form.rain_pcpn), 1)]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "空气质量"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(weatherData).form.air), 1)]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "空气质量等级"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(weatherData).form.air_level), 1)]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "空气质量描述"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(weatherData).form.air_tips), 1)]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _cache[47] || (_cache[47] = _createElementVNode("h3", {
            style: {
              "margin": "0.8rem",
              "color": "#48D1CC"
            }
          }, "空气质量指数:", -1)), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "空气质量"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(weatherData).aqi.air), 1)]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "空气质量等级"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(weatherData).aqi.air_level), 1)]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "PM2.5"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(weatherData).aqi.pm25), 1)]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "PM2.5等级描述"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(weatherData).aqi.pm25_desc), 1)]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "PM10"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(weatherData).aqi.pm10), 1)]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "PM10等级描述"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(weatherData).aqi.pm10_desc), 1)]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "o3"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(weatherData).aqi.o3), 1)]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "o3等级描述"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(weatherData).aqi.o3_desc), 1)]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "no2"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(weatherData).aqi.no2), 1)]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "no2等级描述"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(weatherData).aqi.no2_desc), 1)]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "so2"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(weatherData).aqi.so2), 1)]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "so2等级描述"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(weatherData).aqi.so2_desc), 1)]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "是否需要带口罩"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(weatherData).aqi.kouzhao), 1)]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "外出适宜"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(weatherData).aqi.waichu), 1)]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "开窗适宜"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(weatherData).aqi.kaichuang), 1)]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "是否需要打开净化器"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(weatherData).aqi.jinghuaqi), 1)]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "空气质量提示"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(weatherData).aqi.air_tips), 1)]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })])])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
        title: "链路状态",
        modelValue: _unref(openPingResultInfo),
        "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => _isRef(openPingResultInfo) ? openPingResultInfo.value = $event : null),
        width: "132rem",
        "close-on-click-modal": false,
        "append-to-body": "",
        onBeforeClose: _cache[21] || (_cache[21] = $event => closePingResultDialog()),
        draggable: ""
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_36, [_createElementVNode("div", _hoisted_37, [_createVNode(_component_el_radio_group, {
          modelValue: _unref(pingViewMode),
          "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => _isRef(pingViewMode) ? pingViewMode.value = $event : null),
          size: "small",
          class: "satpro-radio-group"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_radio_button, {
            label: "card",
            class: "satpro-radio-button"
          }, {
            default: _withCtx(() => [...(_cache[48] || (_cache[48] = [_createTextVNode("监控面板", -1)]))]),
            _: 1
          }), _createVNode(_component_el_radio_button, {
            label: "list",
            class: "satpro-radio-button"
          }, {
            default: _withCtx(() => [...(_cache[49] || (_cache[49] = [_createTextVNode("历史查询", -1)]))]),
            _: 1
          })]),
          _: 1
        }, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_38, [_createElementVNode("div", _hoisted_39, [_unref(pingViewMode) === 'card' ? (_openBlock(), _createElementBlock("div", _hoisted_40, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(targets), target => {
          return _openBlock(), _createElementBlock("div", {
            key: target.ip,
            class: _normalizeClass(["ip-card", {
              'status-online': _unref(latestResults)[target.ip]?.success,
              'status-offline': !_unref(latestResults)[target.ip]?.success
            }])
          }, [_createElementVNode("div", _hoisted_41, [_createElementVNode("h3", null, _toDisplayString(target.name), 1), _createElementVNode("span", {
            class: _normalizeClass(["status-dot", getStatusClass(target.ip)])
          }, null, 2)]), _createElementVNode("div", _hoisted_42, [_createElementVNode("div", _hoisted_43, [_createElementVNode("div", _hoisted_44, [_cache[50] || (_cache[50] = _createElementVNode("span", {
            class: "label"
          }, "当前延迟:", -1)), _createElementVNode("span", {
            class: _normalizeClass(["value", getLatencyClass(target.ip)])
          }, _toDisplayString(getLatencyDisplay(target.ip)), 3)]), _createElementVNode("div", _hoisted_45, [_cache[51] || (_cache[51] = _createElementVNode("span", {
            class: "label"
          }, "平均延迟:", -1)), _createElementVNode("span", _hoisted_46, _toDisplayString(getAvgLatency(target.ip)) + "ms", 1)]), _createElementVNode("div", _hoisted_47, [_cache[52] || (_cache[52] = _createElementVNode("span", {
            class: "label"
          }, "丢包率(近1分钟):", -1)), _createElementVNode("span", {
            class: _normalizeClass(["value", getPacketLoss1m(target.ip) > 0 ? 'text-danger' : 'text-success'])
          }, _toDisplayString(getPacketLoss1m(target.ip)) + "% ", 3)]), _createElementVNode("div", _hoisted_48, [_cache[53] || (_cache[53] = _createElementVNode("span", {
            class: "label"
          }, "丢包率(总计):", -1)), _createElementVNode("span", {
            class: _normalizeClass(["value", getPacketLoss(target.ip) > 0 ? 'text-danger' : 'text-success'])
          }, _toDisplayString(getPacketLoss(target.ip)) + "% ", 3)])])]), _createVNode(_unref(LatencyChart), {
            ip: target.ip,
            results: getLast1MinData(target.ip)
          }, null, 8, ["ip", "results"])], 2);
        }), 128))])) : _unref(pingViewMode) === 'list' ? (_openBlock(), _createElementBlock("div", _hoisted_49, [_createElementVNode("div", _hoisted_50, [_createElementVNode("div", _hoisted_51, [_cache[54] || (_cache[54] = _createElementVNode("label", null, "IP地址:", -1)), _createVNode(_component_el_select, {
          modelValue: _unref(selectedIp),
          "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => _isRef(selectedIp) ? selectedIp.value = $event : null),
          placeholder: "选择链路",
          style: {
            "width": "180px"
          }
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(targets), target => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: target.ip,
              value: target.ip,
              label: target.name
            }, null, 8, ["value", "label"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_52, [_cache[55] || (_cache[55] = _createElementVNode("label", null, "时间范围:", -1)), _createVNode(_component_el_select, {
          modelValue: _unref(timeRange),
          "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => _isRef(timeRange) ? timeRange.value = $event : null),
          placeholder: "选择时间范围",
          style: {
            "width": "150px"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_option, {
            value: 5,
            label: "最近5分钟"
          }), _createVNode(_component_el_option, {
            value: 10,
            label: "最近10分钟"
          }), _createVNode(_component_el_option, {
            value: 60,
            label: "最近1小时"
          }), _createVNode(_component_el_option, {
            value: 0,
            label: "全部"
          })]),
          _: 1
        }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_53, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: queryHistory,
          icon: "Search"
        }, {
          default: _withCtx(() => [...(_cache[56] || (_cache[56] = [_createTextVNode("查询", -1)]))]),
          _: 1
        })])]), _unref(selectedIp) && _unref(historyResults).length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_54, [_createVNode(_unref(LatencyChart), {
          name: getCurrentName(_unref(selectedIp)),
          results: _unref(historyResults),
          showAll: true
        }, null, 8, ["name", "results"])])) : _createCommentVNode("", true), _unref(historyResults).length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_55, [_createElementVNode("div", _hoisted_56, [_cache[57] || (_cache[57] = _createElementVNode("div", {
          class: "label"
        }, "平均延迟", -1)), _createElementVNode("div", _hoisted_57, _toDisplayString(_unref(avgLatency)) + "ms", 1)]), _createElementVNode("div", _hoisted_58, [_cache[58] || (_cache[58] = _createElementVNode("div", {
          class: "label"
        }, "最大延迟", -1)), _createElementVNode("div", _hoisted_59, _toDisplayString(_unref(maxLatency)) + "ms", 1)]), _createElementVNode("div", _hoisted_60, [_cache[59] || (_cache[59] = _createElementVNode("div", {
          class: "label"
        }, "最小延迟", -1)), _createElementVNode("div", _hoisted_61, _toDisplayString(_unref(minLatency)) + "ms", 1)]), _createElementVNode("div", _hoisted_62, [_cache[60] || (_cache[60] = _createElementVNode("div", {
          class: "label"
        }, "丢包率", -1)), _createElementVNode("div", _hoisted_63, _toDisplayString(_unref(packetLoss)) + "%", 1)])])) : _createCommentVNode("", true), _unref(selectedIp) && _unref(historyResults).length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_64, [_createVNode(_component_el_empty, {
          description: "暂无历史数据"
        })])) : _createCommentVNode("", true), !_unref(selectedIp) ? (_openBlock(), _createElementBlock("div", _hoisted_65, [_createVNode(_component_el_empty, {
          description: "请选择要查询的IP地址"
        })])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)])])]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }
};